import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { XCircleIcon, CheckCircleIcon, PlusIcon, TrashIcon, ExclamationIcon, ChevronLeftIcon, ChevronDownIcon } from '@heroicons/react/solid'
import Cookies from 'js-cookie'
import Loader from '../UI/Loader'
import tools from '../../tools'
import './Precheckin.css'

const VEHICLE_BRANDS = [
	'Alfa Romeo', 'Aston Martin', 'Audi', 'Chevrolet', 'Citroën', 'Corvette',
	'Dacia', 'Ferrari', 'Fiat', 'Ford', 'Honda', 'Hyundai', 'Infiniti',
	'Jaguar', 'Jeep', 'Kia', 'Lada', 'Lamborghini', 'Lancia', 'Land Rover',
	'Lexus', 'Lotus', 'Maserati', 'Mazda', 'Mercedes', 'Mini', 'Mitsubishi',
	'Nissan', 'Opel', 'Peugeot', 'Porsche', 'Renault', 'Rolls-Royce',
	'Saab', 'SEAT', 'Škoda', 'Smart', 'SsangYong', 'Subaru', 'Suzuki',
	'Tesla', 'Toyota', 'Volkswagen', 'Volvo'
]

const COUNTRIES = [
	// Europe UE
	{ code: 'AT', flag: '🇦🇹' },
	{ code: 'BE', flag: '🇧🇪' },
	{ code: 'BG', flag: '🇧🇬' },
	{ code: 'CY', flag: '🇨🇾' },
	{ code: 'CZ', flag: '🇨🇿' },
	{ code: 'DE', flag: '🇩🇪' },
	{ code: 'DK', flag: '🇩🇰' },
	{ code: 'EE', flag: '🇪🇪' },
	{ code: 'ES', flag: '🇪🇸' },
	{ code: 'FI', flag: '🇫🇮' },
	{ code: 'FR', flag: '🇫🇷' },
	{ code: 'GR', flag: '🇬🇷' },
	{ code: 'HR', flag: '🇭🇷' },
	{ code: 'HU', flag: '🇭🇺' },
	{ code: 'IE', flag: '🇮🇪' },
	{ code: 'IT', flag: '🇮🇹' },
	{ code: 'LT', flag: '🇱🇹' },
	{ code: 'LU', flag: '🇱🇺' },
	{ code: 'LV', flag: '🇱🇻' },
	{ code: 'MT', flag: '🇲🇹' },
	{ code: 'NL', flag: '🇳🇱' },
	{ code: 'PL', flag: '🇵🇱' },
	{ code: 'PT', flag: '🇵🇹' },
	{ code: 'RO', flag: '🇷🇴' },
	{ code: 'SE', flag: '🇸🇪' },
	{ code: 'SI', flag: '🇸🇮' },
	{ code: 'SK', flag: '🇸🇰' },
	// Europe hors UE
	{ code: 'AD', flag: '🇦🇩' },
	{ code: 'AL', flag: '🇦🇱' },
	{ code: 'BA', flag: '🇧🇦' },
	{ code: 'BY', flag: '🇧🇾' },
	{ code: 'CH', flag: '🇨🇭' },
	{ code: 'GB', flag: '🇬🇧' },
	{ code: 'IS', flag: '🇮🇸' },
	{ code: 'LI', flag: '🇱🇮' },
	{ code: 'MC', flag: '🇲🇨' },
	{ code: 'MD', flag: '🇲🇩' },
	{ code: 'ME', flag: '🇲🇪' },
	{ code: 'MK', flag: '🇲🇰' },
	{ code: 'NO', flag: '🇳🇴' },
	{ code: 'RS', flag: '🇷🇸' },
	{ code: 'RU', flag: '🇷🇺' },
	{ code: 'SM', flag: '🇸🇲' },
	{ code: 'TR', flag: '🇹🇷' },
	{ code: 'UA', flag: '🇺🇦' },
	{ code: 'VA', flag: '🇻🇦' },
	{ code: 'XK', flag: '🇽🇰' },
	// Maghreb
	{ code: 'DZ', flag: '🇩🇿' },
	{ code: 'LY', flag: '🇱🇾' },
	{ code: 'MA', flag: '🇲🇦' },
	{ code: 'MR', flag: '🇲🇷' },
	{ code: 'TN', flag: '🇹🇳' },
]

const LANG_NAMES = {
	fr: '🇫🇷 Français',
	en: '🇬🇧 English',
	de: '🇩🇪 Deutsch',
	nl: '🇳🇱 Nederlands',
	it: '🇮🇹 Italiano',
	es: '🇪🇸 Español',
	pt: '🇵🇹 Português'
}

const parseName = (val) => val.toLowerCase().replace(/(^|[\s\-'])(.)/g, (_, sep, c) => sep + c.toUpperCase())

class Precheckin extends Component {
	constructor(props) {
		super(props)
		this.birthdayDayRef = React.createRef()
		this.birthdayMonthRef = React.createRef()
		this.birthdayYearRef = React.createRef()

		this.state = {
			step: 0,
			nav_direction: 1,
			max_step_reached: 0,
			redirect: false,
			error: null,
			field_errors: {},
			open_participants: {},
			loading_client: true,
			loading_stays: true,
			loading_precheckins: true,
			loading: false,
			submitted: false,

			// Séjours
			stays: [],
			selected_stay: null,

			// Étape 1 - Informations du client
			client: {
				civility: '',
				lastname: '',
				firstname: '',
				birthday: '',
				place_of_birth: '',
				email: '',
				phone: '',
				street: '',
				zipcode: '',
				city: '',
				country: '',
				id_type: '',
				id_number: ''
			},

			// Étape 3 - Participants additionnels
			nb_participants: 0,
			participants: [],

			// Étape 4 - Véhicules
			vehicles: [],

			// Étape 5 - Animaux
			animals: [],

			// Étape 6 - Heure d'arrivée
			estimate_arrival: '12:00',
			estimate_arrivals: {},

			// Précheckin déjà soumis
			existing_precheckins: [],

			// Langue sélectionnée
			selected_lang: null,

			// Confirmation — création de compte
			user_exists: null,
			show_password_form: false,
			new_password: '',
			creating_account: false,
			account_error: null,

			// Incitation notifications push
			show_notification_prompt: false
		}
	}

	componentDidMount() {
		this.props.updateLogs(this.props.history.location.pathname, 'Precheckin')
		// showPrevious=false : la flèche flottante du shell recouvrait le header
		// du parcours et son history.back abandonnait tout le pré-checkin
		this.props.updateShell('profile', false, this.props.history.location.pathname, true)

		const initial_lang = this.props.lang_default || (this.props.langs && this.props.langs[0]) || 'fr'
		this.setState({ selected_lang: initial_lang })

		const client_number = this.getClientNumber()
		if (!client_number)
		{
			this.setState({ loading_client: false, loading_stays: false, loading_precheckins: false })
			return ;
		}

		const now = Math.round(Date.now() / 1000)
		Promise.all([
			this.props.fetchClientByNumber(client_number).catch(() => null),
			this.props.fetchPrecheckinByClient(client_number).catch(() => []),
			this.props.fetchPrecheckinStays(client_number).catch(() => [])
		])
		.then(([crm_client, precheckins, allStays]) => {
			const stays = (allStays || []).filter(s => !s.cancelled && s.departure_time && s.departure_time >= now)
			const existing_precheckins = precheckins || []

			let client_state = {
				civility: '',
				lastname: '',
				firstname: '',
				birthday: '',
				place_of_birth: '',
				email: '',
				phone: '',
				street: '',
				zipcode: '',
				city: '',
				country: '',
				id_type: '',
				id_number: ''
			}

			if (crm_client)
			{
				client_state = {
					civility: crm_client.civility || '',
					lastname: crm_client.lastname || '',
					firstname: crm_client.firstname || '',
					birthday: crm_client.birthday || '',
					place_of_birth: crm_client.place_of_birth || '',
					email: crm_client.email1 || '',
					phone: crm_client.phone1 || '',
					street: crm_client.street1 || '',
					zipcode: crm_client.zipcode || '',
					city: crm_client.city || '',
					country: crm_client.country || '',
					id_type: '',
					id_number: ''
				}
			}

				let prefill_selected_stay = stays.length === 1 ? stays[0].stay_number : null

			if (existing_precheckins.length > 0)
			{
				const latest = existing_precheckins[existing_precheckins.length - 1]
				client_state = {
					civility: latest.civility || client_state.civility,
					lastname: latest.lastname || client_state.lastname,
					firstname: latest.firstname || client_state.firstname,
					birthday: latest.birthday || client_state.birthday,
					place_of_birth: latest.place_of_birth || client_state.place_of_birth,
					email: latest.email || client_state.email,
					phone: latest.phone || client_state.phone,
					street: latest.street || client_state.street,
					zipcode: latest.zipcode || client_state.zipcode,
					city: latest.city || client_state.city,
					country: latest.country || client_state.country,
					id_type: latest.id_type || client_state.id_type,
					id_number: latest.id_number || client_state.id_number
				}
			}

			let all_compiled_participants = []
			let all_vehicles = []
			let all_animals = []
			const cc = this.props.config_checkins || {}
			// Pré-remplissage : heure d'arrivée du type du 1er séjour (stay-hours),
			// repli sur l'horaire historique puis 12:00
			const first_stay_hours = this._getStayHours(stays.length > 0 ? stays[0] : null)
			const default_arrival_hour = first_stay_hours.arrival != null
				? String(first_stay_hours.arrival).padStart(2, '0') + ':00'
				: (cc.arrival_time_hour != null ? String(cc.arrival_time_hour).padStart(2, '0') + ':00' : '12:00')
			let estimate_arrival = default_arrival_hour
			const estimate_arrivals = {}

			for (let i = 0; i < existing_precheckins.length; i++)
			{
				const pc = existing_precheckins[i]
				const stay = stays.find(s => s.stay_number === pc.stay_number) || null
				if (!stay)
					continue

				if (pc.participants && pc.participants.length > 0)
				{
					const with_stay = pc.participants.map(p => ({ ...p, stay_number: p.stay_number || pc.stay_number }))
					all_compiled_participants = all_compiled_participants.concat(with_stay)
				}

				if (pc.vehicles && pc.vehicles.length > 0)
				{
					const with_stay = pc.vehicles.map(v => ({ ...v, stay_number: pc.stay_number }))
					all_vehicles = all_vehicles.concat(with_stay)
				}

				if (pc.animals && pc.animals.length > 0)
				{
					const with_stay = pc.animals.map(a => ({ ...a, stay_number: pc.stay_number }))
					all_animals = all_animals.concat(with_stay)
				}

				if (pc.estimate_arrival !== null && pc.estimate_arrival !== undefined)
				{
					const h = Math.floor(pc.estimate_arrival / 3600)
					const m = Math.floor((pc.estimate_arrival % 3600) / 60)
					const time_str = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0')
					if (stay.arrival)
						estimate_arrivals[stay.arrival] = time_str
					estimate_arrival = time_str
				}
			}

			if (all_compiled_participants.length === 0)
			{
				for (let i = 0; i < stays.length; i++)
				{
					const stay = stays[i]
					if (stay.participants && stay.participants.length > 0)
					{
						const with_stay = stay.participants.map(p => ({
							lastname: p.lastname || '',
							firstname: p.firstname || '',
							birthday: p.birthday || '',
							email: '',
							stay_number: stay.stay_number
						}))
						all_compiled_participants = all_compiled_participants.concat(with_stay)
					}
				}
			}

			const client_email = (client_state.email || '').toLowerCase().trim()
			const client_lastname = (client_state.lastname || '').toLowerCase().trim()
			const client_firstname = (client_state.firstname || '').toLowerCase().trim()

			let main_idx = -1
			if (client_email)
				main_idx = all_compiled_participants.findIndex(p => (p.email || '').toLowerCase().trim() === client_email)
			if (main_idx === -1 && client_lastname && client_firstname)
				main_idx = all_compiled_participants.findIndex(p =>
					(p.lastname || '').toLowerCase().trim() === client_lastname &&
					(p.firstname || '').toLowerCase().trim() === client_firstname
				)

			if (main_idx !== -1)
			{
				const main = all_compiled_participants[main_idx]
				if (!client_state.birthday && main.birthday)
					client_state.birthday = main.birthday
				if (main.stay_number)
					prefill_selected_stay = main.stay_number
			}

			const all_participants = main_idx !== -1
				? all_compiled_participants.filter((_, idx) => idx !== main_idx)
				: all_compiled_participants.slice(1)

			let init_participants = all_participants
			if (all_participants.length === 0 && stays.length > 1)
			{
				const min_slots = stays.length - 1
				init_participants = []
				for (let k = 0; k < min_slots; k++)
					init_participants.push({ lastname: '', firstname: '', birthday: '', email: '', stay_number: null })
			}

			this.setState({
				loading_client: false,
				loading_stays: false,
				loading_precheckins: false,
				stays,
				selected_stay: prefill_selected_stay,
				client: client_state,
				participants: init_participants,
				nb_participants: init_participants.length,
				vehicles: all_vehicles,
				animals: all_animals,
				estimate_arrival,
				estimate_arrivals,
				existing_precheckins
			})
			if (crm_client && this.props.user && this.props.user.invite === true && this.props.postUpdateDeviceClientNumber)
				this.props.postUpdateDeviceClientNumber(client_number)
		})
		.catch(() => {
			this.setState({ loading_client: false, loading_stays: false, loading_precheckins: false })
		})
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.step !== this.state.step || prevState.submitted !== this.state.submitted)
		{
			const wrapper = document.getElementById('wrapper')
			if (wrapper)
				wrapper.scrollTop = 0
		}
	}

	getClientNumber = () => {
		return this.props.match && this.props.match.params && this.props.match.params.client_number
			? this.props.match.params.client_number
			: null
	}

	_getLangAssets = () => {
		const lang = this.state.selected_lang
		const assets = this.props.all_lang_assets
		return (lang && assets && assets[lang]) ? assets[lang] : this.props.lang_assets
	}

	handleLangChange = (lang) => {
		this.setState({ selected_lang: lang })
		if (this.props.updateUser && this.props.user)
			this.props.updateUser({ ...this.props.user, langage: lang }, this.props.session)
	}

	setErrorMsg = (msg) => {
		this.setState({ error: msg })
	}

	clearFlash = () => {
		this.setState({ error: null })
	}

	// --- Erreurs par champ ---

	// Applique la carte d'erreurs d'une étape ; scroll vers le premier champ
	// fautif. Retourne true si l'étape est valide.
	_applyFieldErrors = (errors) => {
		if (Object.keys(errors).length === 0)
		{
			this.setState({ field_errors: {} })
			return true
		}
		this.setState({ field_errors: errors }, this._scrollToFirstError)
		return false
	}

	_scrollToFirstError = () => {
		const el = document.querySelector('.pc-field-error')
		if (el && el.scrollIntoView)
			el.scrollIntoView({ behavior: 'smooth', block: 'center' })
	}

	_clearFieldError = (key) => {
		if (!this.state.field_errors[key])
			return ;
		this.setState(prev => {
			const field_errors = { ...prev.field_errors }
			delete field_errors[key]
			return { field_errors }
		})
	}

	_inputClass = (key, extra = '') => {
		return 'pc-input' + (this.state.field_errors[key] ? ' pc-err' : '') + (extra ? ' ' + extra : '')
	}

	_renderFieldError = (key) => {
		const msg = this.state.field_errors[key]
		if (!msg)
			return null
		return <p role="alert" className="pc-field-error text-sm font-medium text-red-600 mt-1 mb-0">{msg}</p>
	}

	// --- Séjour ---

	handleSelectedStay = (e) => {
		this.clearFlash()
		this._clearFieldError('selected_stay')
		const val = e.target.value
		this.setState({ selected_stay: val ? parseInt(val, 10) : null })
	}

	// --- Étape 1 : Infos client ---

	handleClientField = (field, value) => {
		this._clearFieldError(field)
		this.setState(prev => ({
			client: { ...prev.client, [field]: value }
		}))
	}

	blurClientName = (field) => {
		const val = this.state.client[field]
		if (val && val.trim())
			this.handleClientField(field, parseName(val))
	}

	_getBirthdayParts = () => {
		const parts = (this.state.client.birthday || '').split('/')
		return { day: parts[0] || '', month: parts[1] || '', year: parts[2] || '' }
	}

	_setBirthday = (day, month, year) => {
		this._clearFieldError('birthday')
		this.setState(prev => ({
			client: { ...prev.client, birthday: day + '/' + month + '/' + year }
		}))
	}

	handleBirthdayDay = (e) => {
		const { month, year } = this._getBirthdayParts()
		const result = tools.parseDateDay(e.target.value)
		e.target.setCustomValidity(result.valid ? '' : 'Jour invalide')
		this._setBirthday(result.value, month, year)
		if (result.advance)
			setTimeout(() => this.birthdayMonthRef.current.focus(), 0)
	}

	handleBirthdayDayBlur = (e) => {
		const val = e.target.value
		const { month, year } = this._getBirthdayParts()
		if (val.length === 1)
			this._setBirthday('0' + val, month, year)
	}

	handleBirthdayMonth = (e) => {
		const { day, year } = this._getBirthdayParts()
		const result = tools.parseDateMonth(e.target.value)
		e.target.setCustomValidity(result.valid ? '' : 'Mois invalide')
		this._setBirthday(day, result.value, year)
		if (result.advance)
			setTimeout(() => this.birthdayYearRef.current.focus(), 0)
	}

	handleBirthdayMonthBlur = (e) => {
		const val = e.target.value
		const { day, year } = this._getBirthdayParts()
		if (val.length === 1)
			this._setBirthday(day, '0' + val, year)
	}

	handleBirthdayYear = (e) => {
		const val = e.target.value.replace(/\D/g, '').slice(0, 4)
		const { day, month } = this._getBirthdayParts()
		this._setBirthday(day, month, val)
	}

	handleBirthdayKeyDown = (e, field) => {
		if (e.key !== 'Backspace') return
		const { month, year } = this._getBirthdayParts()
		if (field === 'month' && month.length === 0) {
			e.preventDefault()
			this.birthdayDayRef.current.focus()
		}
		if (field === 'year' && year.length === 0) {
			e.preventDefault()
			this.birthdayMonthRef.current.focus()
		}
	}

	//validation calendaire réelle : Date corrige silencieusement les dates
	//impossibles (31/02 devient le 3 mars), donc si la date construite a bougé,
	//la saisie était invalide ; les bissextiles sont gérées par le calendrier
	_isBirthdayValid = (birthday) => {
		const parts = (birthday || '').split('/')
		if (parts.length !== 3 || parts[2].length !== 4)
			return false
		const day = parseInt(parts[0], 10)
		const month = parseInt(parts[1], 10)
		const year = parseInt(parts[2], 10)
		if (isNaN(day) || isNaN(month) || isNaN(year) || year < 1900)
			return false
		const date = new Date(year, month - 1, day)
		if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day)
			return false
		return (date <= new Date()) ? true : false
	}

	_validateStep1 = () => {
		const { civility, lastname, firstname, birthday, place_of_birth, email, phone, street, zipcode, city, country, id_type, id_number } = this.state.client
		const lang = this._getLangAssets().precheckin
		const mandatory = (this.props.config_checkins && this.props.config_checkins.mandatory) || {}
		const errors = {}
		if (!civility)
			errors.civility = lang.errors.civil_required
		if (!firstname || !firstname.trim())
			errors.firstname = lang.errors.firstname_required
		if (!lastname || !lastname.trim())
			errors.lastname = lang.errors.lastname_required
		if (!birthday || !birthday.replace(/\//g, '').trim())
			errors.birthday = lang.errors.birthday_required
		else if (!this._isBirthdayValid(birthday))
			errors.birthday = lang.errors.birthday_invalid
		if (mandatory.place_of_birth && (!place_of_birth || !place_of_birth.trim()))
			errors.place_of_birth = lang.errors.place_of_birth_required
		if (!email || !email.trim())
			errors.email = lang.errors.email_required
		if (!phone || !phone.trim())
			errors.phone = lang.errors.phone_required
		if (!street || !street.trim())
			errors.street = lang.errors.street_required
		if (!zipcode || !zipcode.trim())
			errors.zipcode = lang.errors.zipcode_required
		if (!city || !city.trim())
			errors.city = lang.errors.city_required
		if (!country || !country.trim())
			errors.country = lang.errors.country_required
		if (mandatory.identity_card && !id_type)
			errors.id_type = lang.errors.id_type_required
		if (mandatory.identity_card && (!id_number || !id_number.trim()))
			errors.id_number = lang.errors.id_number_required
		return this._applyFieldErrors(errors)
	}

	_validateImplicitParticipant = () => {
		const lang = this._getLangAssets().precheckin
		const errors = {}
		if (this.state.stays.length > 1 && !this.state.selected_stay)
			errors.selected_stay = lang.errors.select_stay_required
		return this._applyFieldErrors(errors)
	}

	_validateStep3 = () =>
	{
		const lang = this._getLangAssets().precheckin
		const { stays, participants, selected_stay } = this.state
		const display_names = this._buildStayDisplayNames()
		if (stays.length > 1 && (1 + participants.length) < stays.length)
		{
			this.setErrorMsg(lang.errors.min_participants_required.replace(/{n}/g, stays.length))
			return false
		}
		const errors = {}
		const open_participants = { ...this.state.open_participants }
		for (let i = 0; i < participants.length; i++)
		{
			const p = participants[i]
			const n = i + 1
			if (!p.firstname || !p.firstname.trim())
				errors['p' + i + '_firstname'] = lang.errors.participant_firstname_required.replace('{n}', n)
			if (!p.lastname || !p.lastname.trim())
				errors['p' + i + '_lastname'] = lang.errors.participant_lastname_required.replace('{n}', n)
			if (!p.birthday || !p.birthday.replace(/\//g, '').trim())
				errors['p' + i + '_birthday'] = lang.errors.participant_birthday_required.replace('{n}', n)
			else if (!this._isBirthdayValid(p.birthday))
				errors['p' + i + '_birthday'] = lang.errors.participant_birthday_invalid.replace('{n}', n)
			if (stays.length > 1 && !p.stay_number)
				errors['p' + i + '_stay_number'] = lang.errors.participant_stay_required.replace('{n}', n)
			if (Object.keys(errors).some(k => k.indexOf('p' + i + '_') === 0))
				open_participants[i] = true
		}
		if (Object.keys(errors).length > 0)
		{
			this.setState({ open_participants })
			return this._applyFieldErrors(errors)
		}
		if (stays.length > 1)
		{
			const covered = new Set()
			if (selected_stay) covered.add(Number(selected_stay))
			participants.forEach(p => { if (p.stay_number) covered.add(Number(p.stay_number)) })
			for (let j = 0; j < stays.length; j++)
			{
				if (!covered.has(Number(stays[j].stay_number)))
				{
					const stay_name = display_names[stays[j].stay_number] || ('#' + stays[j].stay_number)
					this.setErrorMsg(lang.errors.stay_no_participant_required.replace('{stay}', stay_name))
					return false
				}
			}
		}
		return this._applyFieldErrors(errors)
	}

	_validateStep4 = () =>
	{
		const lang = this._getLangAssets().precheckin
		const mandatory = (this.props.config_checkins && this.props.config_checkins.mandatory) || {}
		const errors = {}
		for (let i = 0; i < this.state.vehicles.length; i++)
		{
			const v = this.state.vehicles[i]
			const n = i + 1
			if (!v.plate || !v.plate.trim())
				errors['v' + i + '_plate'] = lang.errors.vehicle_plate_required.replace('{n}', n)
			if (!v.country)
				errors['v' + i + '_country'] = lang.errors.vehicle_country_required.replace('{n}', n)
			if (!v.vehicle_type)
				errors['v' + i + '_vehicle_type'] = lang.errors.vehicle_type_required.replace('{n}', n)
			if (this.state.stays.length > 1 && !v.stay_number)
				errors['v' + i + '_stay_number'] = lang.errors.vehicle_stay_required.replace('{n}', n)
			if (mandatory.vehicle_brand && (!v.brand || !v.brand.trim()))
				errors['v' + i + '_brand'] = lang.errors.vehicle_brand_required.replace('{n}', n)
			if (mandatory.vehicle_color && (!v.color || !v.color.trim()))
				errors['v' + i + '_color'] = lang.errors.vehicle_color_required.replace('{n}', n)
		}
		return this._applyFieldErrors(errors)
	}

	_validateStep5 = () =>
	{
		const lang = this._getLangAssets().precheckin
		const mandatory = (this.props.config_checkins && this.props.config_checkins.mandatory) || {}
		const errors = {}
		for (let i = 0; i < this.state.animals.length; i++)
		{
			const a = this.state.animals[i]
			const n = i + 1
			if (!a.type)
				errors['a' + i + '_type'] = lang.errors.animal_type_required.replace('{n}', n)
			if (mandatory.animal_name && (!a.name || !a.name.trim()))
				errors['a' + i + '_name'] = lang.errors.animal_name_required.replace('{n}', n)
			if (mandatory.animal_weight && !a.weight)
				errors['a' + i + '_weight'] = lang.errors.animal_weight_required.replace('{n}', n)
			if (mandatory.animal_chip && (!a.chip || !a.chip.trim()))
				errors['a' + i + '_chip'] = lang.errors.animal_chip_required.replace('{n}', n)
			if (mandatory.animal_last_vaccine && (!a.last_vaccine || !a.last_vaccine.replace(/\//g, '').trim()))
				errors['a' + i + '_last_vaccine'] = lang.errors.animal_last_vaccine_required.replace('{n}', n)
		}
		return this._applyFieldErrors(errors)
	}

	_validateStep6 = () =>
	{
		const lang = this._getLangAssets().precheckin
		const errors = {}
		const unique_dates = [...new Set(this.state.stays.map(s => s.arrival).filter(Boolean))]
		if (unique_dates.length > 1)
		{
			for (let i = 0; i < unique_dates.length; i++)
			{
				if (!this.state.estimate_arrivals[unique_dates[i]])
					errors['arrival_' + unique_dates[i]] = lang.errors.arrival_required
			}
		}
		else if (!this.state.estimate_arrival)
			errors.arrival = lang.errors.arrival_required
		return this._applyFieldErrors(errors)
	}

	// --- Étape 2 : Participants ---

	handleNbParticipants = (value) => {
		this.clearFlash()
		const nb = Math.max(0, Math.min(50, parseInt(value, 10) || 0))
		// Un seul séjour : rattache directement le participant (même logique qu'addVehicle)
		const default_stay = (this.state.stays.length === 1) ? this.state.stays[0].stay_number : null
		let participants = [...this.state.participants]
		if (nb > participants.length) {
			while (participants.length < nb)
				participants.push({ lastname: '', firstname: '', birthday: '', email: '', stay_number: default_stay })
		} else {
			participants = participants.slice(0, nb)
		}
		this.setState({ nb_participants: nb, participants: participants, field_errors: {} })
	}

	_isParticipantComplete = (p) => {
		return !!(p.lastname && p.lastname.trim() && p.firstname && p.firstname.trim() && this._isBirthdayValid(p.birthday))
	}

	toggleParticipant = (index) => {
		this.setState(prev => {
			const open_participants = { ...prev.open_participants }
			const currently_open = open_participants[index] !== undefined
				? open_participants[index]
				: !this._isParticipantComplete(prev.participants[index])
			open_participants[index] = !currently_open
			return { open_participants }
		})
	}

	handleParticipantField = (index, field, value) => {
		this.clearFlash()
		this._clearFieldError('p' + index + '_' + field)
		const participants = [...this.state.participants]
		participants[index] = { ...participants[index], [field]: value }
		this.setState({ participants: participants })
	}

	blurParticipantName = (index, field) => {
		const val = this.state.participants[index][field]
		if (val && val.trim())
			this.handleParticipantField(index, field, parseName(val))
	}

	blurAnimalName = (index) => {
		const val = this.state.animals[index].name
		if (val && val.trim())
			this.handleAnimalField(index, 'name', parseName(val))
	}

	_setParticipantBirthday = (index, day, month, year) => {
		this.handleParticipantField(index, 'birthday', day + '/' + month + '/' + year)
	}

	_getParticipantRef = (index, field) => {
		if (!this._participantRefs) this._participantRefs = {}
		const key = index + '_' + field
		if (!this._participantRefs[key]) this._participantRefs[key] = React.createRef()
		return this._participantRefs[key]
	}

	_getAnimalRef = (index, field) => {
		if (!this._animalRefs) this._animalRefs = {}
		const key = index + '_' + field
		if (!this._animalRefs[key]) this._animalRefs[key] = React.createRef()
		return this._animalRefs[key]
	}

	_setAnimalVaccineDate = (index, day, month, year) => {
		this.handleAnimalField(index, 'last_vaccine', day + '/' + month + '/' + year)
	}

	// --- Étape 3 : Véhicules ---

	handleVehicleField = (index, field, value) => {
		this.clearFlash()
		this._clearFieldError('v' + index + '_' + field)
		const vehicles = [...this.state.vehicles]
		vehicles[index] = { ...vehicles[index], [field]: value }
		this.setState({ vehicles: vehicles })
	}

	addVehicle = () => {
		this.clearFlash()
		// Un seul séjour : rattache directement le véhicule pour qu'il ne soit pas
		// écarté côté serveur si la soumission mélange éléments réhydratés et nouveaux
		const default_stay = (this.state.stays.length === 1) ? this.state.stays[0].stay_number : null
		this.setState(prev => ({ vehicles: [...prev.vehicles, { plate: '', country: 'FR', vehicle_type: '', color: '', brand: '', brand_other: '', stay_number: default_stay }] }))
	}

	removeVehicle = (index) => {
		this.clearFlash()
		const vehicles = this.state.vehicles.filter((_, i) => i !== index)
		this.setState({ vehicles: vehicles })
	}

	// --- Étape 5 : Animaux ---

	handleAnimalField = (index, field, value) => {
		this.clearFlash()
		this._clearFieldError('a' + index + '_' + field)
		const animals = [...this.state.animals]
		animals[index] = { ...animals[index], [field]: value }
		this.setState({ animals: animals })
	}

	addAnimal = () => {
		this.clearFlash()
		this.setState(prev => ({ animals: [...prev.animals, { type: '', type_other: '', name: '', weight: '', chip: '', last_vaccine: '', stay_number: null }] }))
	}

	removeAnimal = (index) => {
		this.clearFlash()
		const animals = this.state.animals.filter((_, i) => i !== index)
		this.setState({ animals: animals })
	}

	// --- Étape 6 : Heure d'arrivée ---

	handleArrivalTime = (time) => {
		this.clearFlash()
		this._clearFieldError('arrival')
		this.setState({ estimate_arrival: time })
	}

	handleArrivalTimeForDate = (arrival_date, time) => {
		this.clearFlash()
		this._clearFieldError('arrival_' + arrival_date)
		this.setState(prev => ({
			estimate_arrivals: { ...prev.estimate_arrivals, [arrival_date]: time }
		}))
	}

	_buildStayDisplayNames = () => {
		const { stays } = this.state
		const category_count = {}
		stays.forEach(s => {
			const cat = s.location_category || null
			if (cat) category_count[cat] = (category_count[cat] || 0) + 1
		})
		const category_index = {}
		const result = {}
		stays.forEach(s => {
			const cat = s.location_category || null
			if (!cat)
			{
				result[s.stay_number] = '#' + s.stay_number
				return
			}
			if (category_count[cat] > 1)
			{
				category_index[cat] = (category_index[cat] || 0) + 1
				result[s.stay_number] = cat + ' ' + category_index[cat]
			}
			else
			{
				result[s.stay_number] = cat
			}
		})
		return result
	}

	// --- Navigation ---

	_nextEnabledStep = (from) => {
		const cc = this.props.config_checkins || {}
		let s = from + 1
		if (s === 3 && cc.participants === false) s++
		if (s === 4 && cc.vehicles === false) s++
		if (s === 5 && cc.animals === false) s++
		return s
	}

	_prevEnabledStep = (from) => {
		const cc = this.props.config_checkins || {}
		let s = from - 1
		if (s === 5 && cc.animals === false) s--
		if (s === 4 && cc.vehicles === false) s--
		if (s === 3 && cc.participants === false) s--
		return s
	}

	_validateCurrentStep = () => {
		if (this.state.step === 1 && !this._validateStep1())
			return false
		if (this.state.step === 2 && !this._validateImplicitParticipant())
			return false
		if (this.state.step === 3 && !this._validateStep3())
			return false
		if (this.state.step === 4 && !this._validateStep4())
			return false
		if (this.state.step === 5 && !this._validateStep5())
			return false
		if (this.state.step === 6 && !this._validateStep6())
			return false
		return true
	}

	goNextStep = () => {
		this.clearFlash()
		if (!this._validateCurrentStep())
			return ;
		this.setState(prev => {
			const next = this._nextEnabledStep(prev.step)
			return { step: next, nav_direction: 1, field_errors: {}, max_step_reached: Math.max(prev.max_step_reached, next) }
		})
	}

	// Saut direct via la barre de progression : libre vers l'arrière, vers
	// l'avant seulement jusqu'à une étape déjà atteinte, et à condition que
	// l'étape courante soit valide (l'intégrité des validations est préservée)
	goToStep = (target) => {
		const { step, max_step_reached } = this.state
		if (target === step)
			return ;
		if (target > step)
		{
			if (target > max_step_reached)
				return ;
			if (!this._validateCurrentStep())
				return ;
		}
		this.clearFlash()
		this.setState({ step: target, nav_direction: target > step ? 1 : -1, field_errors: {} })
	}

	goPrevStep = () => {
		this.clearFlash()
		if (this.state.step === 0)
		{
			this.setState({ redirect: true })
			return ;
		}
		this.setState(prev => ({ step: this._prevEnabledStep(prev.step), nav_direction: -1, field_errors: {} }))
	}

	// Étape heure passable : « Je ne connais pas encore mon heure »
	skipArrivalTime = () => {
		this.clearFlash()
		this.setState(prev => {
			const next = this._nextEnabledStep(prev.step)
			return {
				estimate_arrival: '',
				estimate_arrivals: {},
				step: next,
				nav_direction: 1,
				field_errors: {},
				max_step_reached: Math.max(prev.max_step_reached, next)
			}
		})
	}

	// --- Soumission ---

	handleSubmit = () => {
		this.clearFlash()
		const lang = this._getLangAssets().precheckin
		this.setState({ loading: true })
		const vehicles = this.state.vehicles.filter(v => v.plate.trim() !== '')
		const user = this.props.user
		const { client } = this.state

		const unique_dates = [...new Set(this.state.stays.map(s => s.arrival).filter(Boolean))]
		const is_multi_day = unique_dates.length > 1

		let estimate_arrival = null
		let estimate_arrivals_per_stay = null

		if (is_multi_day)
		{
			estimate_arrivals_per_stay = {}
			this.state.stays.forEach(s => {
				const time_str = this.state.estimate_arrivals[s.arrival]
				if (time_str)
				{
					const parts = time_str.split(':')
					estimate_arrivals_per_stay[s.stay_number] = parseInt(parts[0], 10) * 3600 + parseInt(parts[1], 10) * 60
				}
			})
		}
		else if (this.state.estimate_arrival)
		{
			const parts = this.state.estimate_arrival.split(':')
			estimate_arrival = parseInt(parts[0], 10) * 3600 + parseInt(parts[1], 10) * 60
		}

		const main_participant = {
			lastname: client.lastname,
			firstname: client.firstname,
			birthday: client.birthday,
			email: client.email || null,
			stay_number: this.state.selected_stay || null
		}
		const all_participants = [main_participant, ...this.state.participants]

		this.props.postPrecheckin({
			user_id: user ? user._id : null,
			client_number: this.getClientNumber(),
			selected_stay: this.state.selected_stay || null,
			civility: client.civility || null,
			lastname: client.lastname,
			firstname: client.firstname,
			birthday: client.birthday,
			place_of_birth: client.place_of_birth || null,
			email: client.email,
			phone: client.phone,
			street: client.street,
			zipcode: client.zipcode,
			city: client.city,
			country: client.country,
			id_type: client.id_type || null,
			id_number: client.id_number || null,
			lang: this.state.selected_lang || null,
			participants: all_participants,
			vehicles: vehicles,
			animals: this.state.animals,
			estimate_arrival: estimate_arrival,
			estimate_arrivals_per_stay: estimate_arrivals_per_stay
		})
		.then(ret => {
			if (!ret) {
				this.setState({ loading: false })
				this.setErrorMsg(lang.errors.submit_error)
			} else {
				const notifSupported = 'serviceWorker' in navigator && 'PushManager' in window
				const notifNeeded = notifSupported && typeof Notification !== 'undefined' && Notification.permission === 'default'
				this.setState({ loading: false, submitted: true, show_notification_prompt: notifNeeded })
				if (client.email && client.email.trim() && this.props.postCheckUserEmail)
				{
					this.props.postCheckUserEmail(client.email.trim())
					.then(existing_user => {
						this.setState({ user_exists: !!existing_user })
					})
					.catch(() => {
						this.setState({ user_exists: true })
					})
				}
			}
		})
		.catch(() => {
			this.setState({ loading: false })
			this.setErrorMsg(lang.errors.submit_error)
		})
	}

	// --- Création de compte ---

	createAccount = () => {
		const { new_password, client } = this.state
		const lang = this._getLangAssets().precheckin
		if (new_password.length < 8 || !/[a-zA-Z]/.test(new_password))
		{
			this.setState({ account_error: lang.errors.password_invalid })
			return ;
		}
		this.setState({ creating_account: true, account_error: null })
		this.props.postSubscribeUser({
			civility: client.civility || null,
			lastname: client.lastname,
			firstname: client.firstname,
			email: client.email,
			birthday: client.birthday || null,
			password: new_password,
			client_number: parseInt(this.getClientNumber(), 10) || 0
		})
		.then(created_user => {
			if (!created_user)
			{
				this.setState({ creating_account: false, account_error: lang.errors.account_creation_error })
				return ;
			}
			this.props.postConnectUser({ identifiant: client.email, password: new_password })
			.then(logged_user => {
				if (logged_user && logged_user.session)
				{
					Cookies.set('session', logged_user.session)
					localStorage.setItem('session', logged_user.session)
					this.props.updateUser(logged_user, logged_user.session)
				}
				this.setState({ redirect: true })
			})
			.catch(() => {
				this.setState({ redirect: true })
			})
		})
		.catch(() => {
			this.setState({ creating_account: false, account_error: lang.errors.account_creation_error })
		})
	}

	// --- Rendu helpers ---

	_renderError = () => {
		if (!this.state.error) return null
		return (
			<div className="rounded-md bg-red-50 p-4 mt-3">
				<div className="flex">
					<div className="flex-shrink-0">
						<XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
					</div>
					<div className="ml-3">
						<h3 className="text-sm font-medium text-red-800">{this.state.error}</h3>
					</div>
				</div>
			</div>
		)
	}

	_renderHeader = (title, subtitle) => {
		const themeColor = '#' + this.props.theme.color1
		return (
			<div style={{ backgroundColor: themeColor }} className="h-52 z-0 px-8 text-center">
				{subtitle && <p className="text-xl text-white pt-10">{subtitle}</p>}
				<h1 className={`text-3xl text-white font-semibold m-0 ${subtitle ? 'pt-2' : 'pt-16'}`}>{title}</h1>
			</div>
		)
	}

	// Liste des étapes de formulaire actives (hors intro et récap), selon la config
	_getActiveSteps = () => {
		const cc = this.props.config_checkins || {}
		const steps = [1, 2]
		if (cc.participants !== false)
			steps.push(3)
		if (cc.vehicles !== false)
			steps.push(4)
		if (cc.animals !== false)
			steps.push(5)
		steps.push(6)
		return steps
	}

	_getStepTitle = (step) => {
		const lang = this._getLangAssets().precheckin
		if (step === 1)
			return lang.step1.title
		if (step === 2)
			return lang.step_my_participation.title
		if (step === 3)
			return lang.step2.title
		if (step === 4)
			return lang.step3.title
		if (step === 5)
			return lang.step_animals.title
		if (step === 6)
			return lang.step4.title
		return lang.summary.title
	}

	// Déclinaisons de la couleur du camping : fond de page teinté, halo CTA,
	// fond doux (sélections) et variante foncée (textes sur fond doux)
	_getThemeShades = () => {
		const hex = (this.props.theme.color1 || '000000').replace('#', '')
		const r = parseInt(hex.substring(0, 2), 16) || 0
		const g = parseInt(hex.substring(2, 4), 16) || 0
		const b = parseInt(hex.substring(4, 6), 16) || 0
		const lighten = (c, ratio) => Math.round(c + (255 - c) * ratio)
		const darken = (c, ratio) => Math.round(c * (1 - ratio))
		const rgb = (fn, ratio) => 'rgb(' + fn(r, ratio) + ', ' + fn(g, ratio) + ', ' + fn(b, ratio) + ')'
		return {
			color: '#' + hex,
			page: rgb(lighten, 0.94),
			page_transparent: 'rgba(' + lighten(r, 0.94) + ', ' + lighten(g, 0.94) + ', ' + lighten(b, 0.94) + ', 0)',
			soft: rgb(lighten, 0.88),
			deep: rgb(darken, 0.3),
			glow: 'rgba(' + r + ', ' + g + ', ' + b + ', 0.28)'
		}
	}

	// Carte thématique blanche (maquette) : label uppercase + action optionnelle
	_renderCard = (label, children, action = null) => {
		return (
			<div className="bg-white border border-gray-200 rounded-2xl p-4 mt-4 shadow-sm">
				{(label || action) && (
					<div className="flex items-center justify-between mb-3">
						{label && <p className="text-xs font-bold uppercase tracking-wider text-gray-400 m-0">{label}</p>}
						{action}
					</div>
				)}
				{children}
			</div>
		)
	}

	// Header compact sticky : retour + titre + « N sur M » + barre segmentée
	_renderShellHeader = () => {
		const lang = this._getLangAssets().precheckin
		const shades = this._getThemeShades()
		const active_steps = this._getActiveSteps()
		const { step } = this.state
		const is_summary = step > 6
		const current_idx = active_steps.indexOf(step)
		const step_of = lang.step_of
			.replace('{n}', current_idx + 1)
			.replace('{m}', active_steps.length)
		return (
			<div className="sticky top-0 z-30 bg-white border-b border-gray-200 px-4 pt-3 pb-3">
				<div className="flex items-center gap-3">
					<button
						type="button"
						onClick={this.goPrevStep}
						aria-label={lang.back}
						className="h-11 w-11 -my-1 rounded-xl border border-gray-200 flex items-center justify-center text-gray-500 flex-shrink-0 bg-white"
					>
						<ChevronLeftIcon className="h-6 w-6" />
					</button>
					<p className="text-base font-bold text-gray-800 truncate m-0">
						{is_summary ? lang.summary.title : this._getStepTitle(step)}
					</p>
					<p className="ml-auto text-xs font-bold text-gray-400 flex-shrink-0 m-0">
						{is_summary ? '✓' : step_of}
					</p>
				</div>
				<div className="flex gap-1 mt-3">
					{active_steps.map((s, i) => {
						const fill = (is_summary || i <= current_idx) ? '100%' : '0%'
						const reachable = s <= this.state.max_step_reached
						return (
							<button
								key={s}
								type="button"
								onClick={() => this.goToStep(s)}
								disabled={!reachable}
								aria-label={this._getStepTitle(s)}
								className="flex-1 bg-transparent border-0 px-0 py-2 -my-2"
								style={{ cursor: reachable ? 'pointer' : 'default' }}
							>
								<span className="block h-1 rounded-full bg-gray-200 overflow-hidden">
									<span
										className="block h-full rounded-full"
										style={{ backgroundColor: shades.color, width: fill, transition: 'width 0.35s ease' }}
									/>
								</span>
							</button>
						)
					})}
				</div>
			</div>
		)
	}

	// CTA sticky bottom : action principale de l'étape, au-dessus de la safe-area
	_renderStickyCta = () => {
		const lang = this._getLangAssets().precheckin
		const shades = this._getThemeShades()
		const { step, loading } = this.state
		const is_summary = step > 6
		let label = lang.next
		if (step === 0)
			label = lang.step0.button
		if (step === 6)
			label = lang.step4.see_summary
		if (is_summary)
			label = loading ? lang.summary.submitting : lang.summary.submit
		return (
			<div
				className="fixed bottom-0 left-0 right-0 z-20 px-4 pt-3"
				style={{
					paddingBottom: 'calc(1rem + env(safe-area-inset-bottom))',
					background: 'linear-gradient(180deg, ' + shades.page_transparent + ', ' + shades.page + ' 40%)'
				}}
			>
				<button
					type="button"
					onClick={is_summary ? this.handleSubmit : this.goNextStep}
					disabled={is_summary && loading}
					className="w-full py-4 rounded-2xl text-white font-bold text-lg disabled:opacity-50"
					style={{ backgroundColor: shades.color, boxShadow: '0 8px 22px ' + shades.glow }}
				>
					{label}
				</button>
				{step === 6 && (
					<button
						type="button"
						onClick={this.skipArrivalTime}
						className="block w-full text-center mt-1 h-11 bg-transparent border-0 text-sm font-bold text-gray-400"
					>
						{lang.step4.unknown_time}
					</button>
				)}
				{step === 0 && (
					<button
						type="button"
						onClick={() => this.setState({ redirect: true })}
						className="block w-full text-center mt-1 h-11 bg-transparent border-0 text-sm font-bold text-gray-400"
					>
						{lang.step0.later}
					</button>
				)}
			</div>
		)
	}

	// --- Étape 0 : Intro + langue ---

	_renderStep0 = () => {
		const lang = this._getLangAssets().precheckin
		const shades = this._getThemeShades()
		const display_names = this._buildStayDisplayNames()
		const { stays } = this.state
		const show_lang_selector = this.props.langs && this.props.langs.length > 1
		const already_submitted = this.state.existing_precheckins.some(pc =>
			pc.estimate_arrival || (pc.participants && pc.participants.length > 0)
		)
		const stay_line = stays.length === 1
			? (display_names[stays[0].stay_number] || ('#' + stays[0].stay_number)) + (stays[0].arrival ? ' · ' + stays[0].arrival : '')
			: stays.map(s => display_names[s.stay_number] || ('#' + s.stay_number)).join(' · ')
		const benefit = (emoji, title, text) => (
			<div className="flex items-start gap-3 py-2">
				<span className="h-10 w-10 rounded-xl flex items-center justify-center text-lg flex-shrink-0" style={{ backgroundColor: shades.soft }} aria-hidden="true">{emoji}</span>
				<span className="min-w-0">
					<span className="block text-sm font-bold text-gray-800">{title}</span>
					<span className="block text-xs text-gray-500 leading-relaxed mt-0.5">{text}</span>
				</span>
			</div>
		)
		return (
			<div className="px-4 pt-5">
				<div className="rounded-3xl p-6 relative overflow-hidden" style={{ background: 'linear-gradient(160deg, ' + shades.color + ', ' + shades.deep + ')' }}>
					<span className="absolute" style={{ right: '-6px', bottom: '-14px', fontSize: '84px', opacity: 0.18, transform: 'rotate(-8deg)' }} aria-hidden="true">🏕️</span>
					<p className="text-xs font-bold uppercase tracking-widest text-white m-0" style={{ opacity: 0.85 }}>{lang.title}</p>
					<h1 className="text-2xl font-extrabold text-white mt-2 mb-0 leading-tight">{lang.step0.hero_title}</h1>
					<p className="text-sm text-white mt-2 mb-0 leading-relaxed" style={{ opacity: 0.92 }}>{lang.step0.intro}</p>
					{stays.length > 0 && (
						<div className="mt-4 rounded-xl px-3 py-2.5 relative" style={{ backgroundColor: 'rgba(255, 255, 255, 0.14)', border: '1px solid rgba(255, 255, 255, 0.25)' }}>
							<p className="text-xs font-bold text-white m-0" style={{ opacity: 0.85 }}>{stays.length > 1 ? lang.step0.stays_label : lang.step0.stay_label}</p>
							<p className="text-sm font-extrabold text-white m-0 mt-0.5">{stay_line}</p>
						</div>
					)}
				</div>

				{already_submitted && (
					<div className="rounded-2xl bg-green-50 border border-green-200 p-4 mt-4">
						<div className="flex items-start gap-3">
							<CheckCircleIcon className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
							<p className="text-sm text-green-800 leading-relaxed m-0">{lang.step0.already_submitted}</p>
						</div>
					</div>
				)}

				{this._renderCard(null, (
					<>
						{benefit('⚡', lang.step0.benefit1_title, lang.step0.benefit1_text)}
						{benefit('🕐', lang.step0.benefit2_title, lang.step0.benefit2_text)}
						{benefit('🔒', lang.step0.benefit3_title, lang.step0.benefit3_text)}
					</>
				))}

				{show_lang_selector && this._renderCard('🌍 ' + lang.step0.lang_label, (
					<div className="flex flex-wrap gap-2">
						{this.props.langs.map(l => {
							const selected = this.state.selected_lang === l
							const flag = (LANG_NAMES[l] || '').split(' ')[0]
							return (
								<button
									key={l}
									type="button"
									onClick={() => this.handleLangChange(l)}
									className="h-11 px-4 rounded-xl text-sm font-bold"
									style={selected
										? { border: '1.5px solid ' + shades.color, backgroundColor: shades.soft, color: shades.deep }
										: { border: '1.5px solid #e5e7eb', backgroundColor: '#fafbfa', color: '#6b7280' }
									}
								>
									{flag} {l.toUpperCase()}
								</button>
							)
						})}
					</div>
				))}

				{this._renderError()}
			</div>
		)
	}

	// --- Étape 1 ---

	_renderStep1 = () => {
		const lang = this._getLangAssets().precheckin
		const { client, field_errors } = this.state
		const { day: bdDay, month: bdMonth, year: bdYear } = this._getBirthdayParts()
		const mandatory = (this.props.config_checkins && this.props.config_checkins.mandatory) || {}
		const shades = this._getThemeShades()
		const labelClass = "block text-xs font-bold text-gray-500 mt-4 mb-1"
		const labelFirstClass = "block text-xs font-bold text-gray-500 mb-1"
		const optionalSuffix = <span className="font-medium text-gray-400 ml-1">({lang.optional})</span>
		const email_valid = /\S+@\S+\.\S+/.test(client.email || '')
		const civility_options = [
			{ value: 'woman', label: lang.step1.civil_madame },
			{ value: 'man', label: lang.step1.civil_monsieur },
			{ value: 'other', label: lang.step1.civil_autre }
		]
		return (
			<div className="px-4 pt-5">
				<h2 className="text-2xl font-extrabold text-gray-800 m-0">{lang.step1.subtitle}</h2>

				{this._renderCard('👤 ' + lang.step1.card_identity, (
					<>
						<label className={labelFirstClass}>{lang.step1.civil}</label>
						<div className="flex gap-2">
							{civility_options.map(opt => {
								const selected = client.civility === opt.value
								return (
									<button
										key={opt.value}
										type="button"
										onClick={() => this.handleClientField('civility', opt.value)}
										className="flex-1 h-12 rounded-xl font-semibold text-sm px-1"
										style={selected
											? { border: '1.5px solid ' + shades.color, backgroundColor: shades.soft, color: shades.deep }
											: { border: '1.5px solid ' + (field_errors.civility ? '#dc2626' : '#e5e7eb'), backgroundColor: '#fafbfa', color: '#6b7280' }
										}
									>
										{opt.label}
									</button>
								)
							})}
						</div>
						{this._renderFieldError('civility')}

						<div className="flex gap-3">
							<div className="flex-1 min-w-0">
								<label className={labelClass}>{lang.step1.firstname}</label>
								<input
									type="text"
									className={this._inputClass('firstname')}
									value={client.firstname}
									onChange={e => this.handleClientField('firstname', e.target.value)}
									onBlur={() => this.blurClientName('firstname')}
								/>
							</div>
							<div className="flex-1 min-w-0">
								<label className={labelClass}>{lang.step1.lastname}</label>
								<input
									type="text"
									className={this._inputClass('lastname')}
									value={client.lastname}
									onChange={e => this.handleClientField('lastname', e.target.value)}
									onBlur={() => this.blurClientName('lastname')}
								/>
							</div>
						</div>
						{this._renderFieldError('firstname')}
						{this._renderFieldError('lastname')}

						<label className={labelClass}>{lang.step1.birthday}</label>
						<div className="flex gap-2">
							<div className="flex-1">
								<input
									ref={this.birthdayDayRef}
									type="text"
									inputMode="numeric"
									value={bdDay}
									onChange={this.handleBirthdayDay}
									onBlur={this.handleBirthdayDayBlur}
									onKeyDown={e => this.handleBirthdayKeyDown(e, 'day')}
									placeholder="JJ"
									maxLength={2}
									className={this._inputClass('birthday', 'text-center')}
								/>
							</div>
							<div className="flex-1">
								<input
									ref={this.birthdayMonthRef}
									type="text"
									inputMode="numeric"
									value={bdMonth}
									onChange={this.handleBirthdayMonth}
									onBlur={this.handleBirthdayMonthBlur}
									onKeyDown={e => this.handleBirthdayKeyDown(e, 'month')}
									placeholder="MM"
									maxLength={2}
									className={this._inputClass('birthday', 'text-center')}
								/>
							</div>
							<div className="flex-1">
								<input
									ref={this.birthdayYearRef}
									type="text"
									inputMode="numeric"
									value={bdYear}
									onChange={this.handleBirthdayYear}
									onKeyDown={e => this.handleBirthdayKeyDown(e, 'year')}
									placeholder="AAAA"
									maxLength={4}
									className={this._inputClass('birthday', 'text-center')}
								/>
							</div>
						</div>
						{this._renderFieldError('birthday')}

						<label className={labelClass}>{lang.step1.place_of_birth}{!mandatory.place_of_birth && optionalSuffix}</label>
						<input
							type="text"
							className={this._inputClass('place_of_birth')}
							value={client.place_of_birth}
							onChange={e => this.handleClientField('place_of_birth', e.target.value)}
							placeholder="ex : Paris"
						/>
						{this._renderFieldError('place_of_birth')}
					</>
				))}

				{this._renderCard('✉️ ' + lang.step1.card_contact, (
					<>
						<label className={labelFirstClass}>{lang.step1.email}</label>
						<input
							type="email"
							className={this._inputClass('email')}
							value={client.email}
							onChange={e => this.handleClientField('email', e.target.value)}
							placeholder="exemple@mail.com"
						/>
						{this._renderFieldError('email')}
						{email_valid && !field_errors.email && (
							<p className="text-sm font-semibold mt-1 mb-0" style={{ color: shades.deep }}>✓ {lang.step1.email_hint}</p>
						)}

						<label className={labelClass}>{lang.step1.phone}</label>
						<input
							type="tel"
							className={this._inputClass('phone')}
							value={client.phone}
							onChange={e => this.handleClientField('phone', e.target.value)}
							placeholder={lang.step1.phone_placeholder}
						/>
						{this._renderFieldError('phone')}
					</>
				))}

				{this._renderCard('🏠 ' + lang.step1.card_address, (
					<>
						<label className={labelFirstClass}>{lang.step1.street}</label>
						<input
							type="text"
							className={this._inputClass('street')}
							value={client.street}
							onChange={e => this.handleClientField('street', e.target.value)}
							placeholder={lang.step1.street_placeholder}
						/>
						{this._renderFieldError('street')}

						<div className="flex gap-3">
							<div className="flex-shrink-0 w-28">
								<label className={labelClass}>{lang.step1.zipcode}</label>
								<input
									type="text"
									className={this._inputClass('zipcode')}
									value={client.zipcode}
									onChange={e => this.handleClientField('zipcode', e.target.value)}
									placeholder="75000"
								/>
							</div>
							<div className="flex-1 min-w-0">
								<label className={labelClass}>{lang.step1.city}</label>
								<input
									type="text"
									className={this._inputClass('city')}
									value={client.city}
									onChange={e => this.handleClientField('city', e.target.value)}
									placeholder={lang.step1.city_placeholder}
								/>
							</div>
						</div>
						{this._renderFieldError('zipcode')}
						{this._renderFieldError('city')}

						<label className={labelClass}>{lang.step1.country}</label>
						<input
							type="text"
							className={this._inputClass('country')}
							value={client.country}
							onChange={e => this.handleClientField('country', e.target.value)}
							placeholder={lang.step1.country_placeholder}
						/>
						{this._renderFieldError('country')}
					</>
				))}

				{this._renderCard('🪪 ' + lang.step1.card_id, (
					<>
						<label className={labelFirstClass}>{lang.step1.id_type}{!mandatory.identity_card && optionalSuffix}</label>
						<select
							className={this._inputClass('id_type')}
							value={client.id_type}
							onChange={e => this.handleClientField('id_type', e.target.value)}
						>
							<option value="">{lang.step1.id_type_placeholder}</option>
							<option value="passport">{lang.step1.id_type_passport}</option>
							<option value="id_card">{lang.step1.id_type_id_card}</option>
							<option value="driving_license">{lang.step1.id_type_driving_license}</option>
						</select>
						{this._renderFieldError('id_type')}

						<label className={labelClass}>{lang.step1.id_number}{!mandatory.identity_card && optionalSuffix}</label>
						<input
							type="text"
							className={this._inputClass('id_number', 'uppercase')}
							value={client.id_number}
							onChange={e => this.handleClientField('id_number', e.target.value.toUpperCase())}
							placeholder="ex : AB123456"
						/>
						{this._renderFieldError('id_number')}
					</>
				))}

				{this._renderError()}
			</div>
		)
	}

	// --- Étape 2 : Ma participation ---

	_renderStepMyParticipation = () => {
		const lang = this._getLangAssets().precheckin
		const display_names = this._buildStayDisplayNames()
		const { client } = this.state
		const { day: bdDay, month: bdMonth, year: bdYear } = this._getBirthdayParts()
		const labelClass = "block text-xs font-bold text-gray-500 mt-4 mb-1"
		const labelFirstClass = "block text-xs font-bold text-gray-500 mb-1"
		const optionalSuffix = <span className="font-medium text-gray-400 ml-1">({lang.optional})</span>
		return (
			<div className="px-4 pt-5">
				<h2 className="text-2xl font-extrabold text-gray-800 m-0">{lang.step_my_participation.subtitle}</h2>

				{this._renderCard('👤 ' + lang.step1.card_identity, (
					<>
						<div className="flex gap-3">
							<div className="flex-1 min-w-0">
								<label className={labelFirstClass}>{lang.step1.firstname}</label>
								<input
									type="text"
									className={this._inputClass('firstname')}
									value={client.firstname}
									onChange={e => this.handleClientField('firstname', e.target.value)}
									onBlur={() => this.blurClientName('firstname')}
								/>
							</div>
							<div className="flex-1 min-w-0">
								<label className={labelFirstClass}>{lang.step1.lastname}</label>
								<input
									type="text"
									className={this._inputClass('lastname')}
									value={client.lastname}
									onChange={e => this.handleClientField('lastname', e.target.value)}
									onBlur={() => this.blurClientName('lastname')}
								/>
							</div>
						</div>

						<label className={labelClass}>{lang.step1.birthday}</label>
						<div className="flex gap-2">
							<div className="flex-1">
								<input
									ref={this.birthdayDayRef}
									type="text"
									inputMode="numeric"
									value={bdDay}
									onChange={this.handleBirthdayDay}
									onBlur={this.handleBirthdayDayBlur}
									onKeyDown={e => this.handleBirthdayKeyDown(e, 'day')}
									placeholder="JJ"
									maxLength={2}
									className={this._inputClass('birthday', 'text-center')}
								/>
							</div>
							<div className="flex-1">
								<input
									ref={this.birthdayMonthRef}
									type="text"
									inputMode="numeric"
									value={bdMonth}
									onChange={this.handleBirthdayMonth}
									onBlur={this.handleBirthdayMonthBlur}
									onKeyDown={e => this.handleBirthdayKeyDown(e, 'month')}
									placeholder="MM"
									maxLength={2}
									className={this._inputClass('birthday', 'text-center')}
								/>
							</div>
							<div className="flex-1">
								<input
									ref={this.birthdayYearRef}
									type="text"
									inputMode="numeric"
									value={bdYear}
									onChange={this.handleBirthdayYear}
									onKeyDown={e => this.handleBirthdayKeyDown(e, 'year')}
									placeholder="AAAA"
									maxLength={4}
									className={this._inputClass('birthday', 'text-center')}
								/>
							</div>
						</div>

						<label className={labelClass}>{lang.step1.email}{optionalSuffix}</label>
						<input
							type="email"
							className={this._inputClass('email')}
							value={client.email}
							onChange={e => this.handleClientField('email', e.target.value)}
							placeholder="exemple@mail.com"
						/>
					</>
				))}

				{this.state.stays.length > 1 && this._renderCard('🏕️ ' + lang.step1.select_stay, (
					<>
						<select
							className={this._inputClass('selected_stay')}
							value={this.state.selected_stay || ''}
							onChange={this.handleSelectedStay}
						>
							<option value="">{lang.step1.select_stay_placeholder}</option>
							{this.state.stays.map(s => (
								<option key={s.stay_number} value={s.stay_number}>
									{display_names[s.stay_number] || ('#' + s.stay_number)}{s.arrival ? ' — ' + s.arrival : ''}
								</option>
							))}
						</select>
						{this._renderFieldError('selected_stay')}
					</>
				))}

				{this._renderError()}
			</div>
		)
	}

	// --- Étape 3 : Participants additionnels ---

	_renderStep2 = () => {
		const lang = this._getLangAssets().precheckin
		const display_names = this._buildStayDisplayNames()
		const shades = this._getThemeShades()
		const { participants, nb_participants, open_participants, field_errors, stays } = this.state
		const labelClass = "block text-xs font-bold text-gray-500 mt-4 mb-1"
		const optionalSuffix = <span className="font-medium text-gray-400 ml-1">({lang.optional})</span>
		return (
			<div className="px-4 pt-5">
				<h2 className="text-2xl font-extrabold text-gray-800 m-0">{lang.step2.subtitle}</h2>

				{this._renderCard(lang.step2.nb_participants, (
					<div className="flex items-center justify-between rounded-2xl p-2" style={{ border: '1.5px solid #e5e7eb', backgroundColor: '#fafbfa' }}>
						<button
							type="button"
							onClick={() => this.handleNbParticipants(nb_participants - 1)}
							disabled={nb_participants <= 0}
							aria-label="-"
							className="h-12 w-12 rounded-xl text-2xl font-bold bg-white border-0 disabled:opacity-40"
							style={{ color: shades.deep, boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)' }}
						>
							−
						</button>
						<div className="text-center">
							<p className="text-3xl font-extrabold text-gray-800 m-0 leading-none">{nb_participants}</p>
							<p className="text-xs font-bold uppercase tracking-wide text-gray-400 m-0 mt-1">
								{nb_participants > 1 ? lang.step2.persons : lang.step2.person}
							</p>
						</div>
						<button
							type="button"
							onClick={() => this.handleNbParticipants(nb_participants + 1)}
							disabled={nb_participants >= 50}
							aria-label="+"
							className="h-12 w-12 rounded-xl text-2xl font-bold bg-white border-0 disabled:opacity-40"
							style={{ color: shades.deep, boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)' }}
						>
							+
						</button>
					</div>
				))}

				{participants.map((p, i) => {
					const parts = (p.birthday || '').split('/')
					const pDay = parts[0] || ''
					const pMonth = parts[1] || ''
					const pYear = parts[2] || ''
					const complete = this._isParticipantComplete(p)
					const open = open_participants[i] !== undefined ? open_participants[i] : !complete
					const has_error = Object.keys(field_errors).some(k => k.indexOf('p' + i + '_') === 0)
					const initials = ((p.firstname || '').charAt(0) + (p.lastname || '').charAt(0)).toUpperCase()
					const stay = stays.length > 1 && p.stay_number ? stays.find(s => s.stay_number === p.stay_number) : null
					const stay_name = stay ? (display_names[stay.stay_number] || ('#' + stay.stay_number)) : null
					return (
						<div
							key={i}
							className="bg-white rounded-2xl p-3 mt-3"
							style={{ border: '1.5px solid ' + (has_error ? '#dc2626' : (open ? shades.color : '#e5e7eb')) }}
						>
							<button
								type="button"
								onClick={() => this.toggleParticipant(i)}
								className="w-full h-12 flex items-center gap-3 bg-transparent border-0 p-0 text-left"
							>
								<span className="h-10 w-10 rounded-xl flex items-center justify-center font-bold text-sm flex-shrink-0" style={{ backgroundColor: shades.soft, color: shades.deep }}>
									{initials || '?'}
								</span>
								<span className="flex-1 min-w-0">
									<span className="block text-sm font-bold text-gray-800 truncate">
										{(p.firstname || p.lastname) ? (p.firstname + ' ' + p.lastname).trim() : lang.step2.participant + ' ' + (i + 1)}
									</span>
									<span className="block text-xs font-semibold text-gray-400 truncate">
										{complete ? p.birthday + (stay_name ? ' · ' + stay_name : '') : lang.step2.to_complete}
									</span>
								</span>
								{complete && !open ? (
									<span className="text-lg flex-shrink-0" style={{ color: shades.color }}>✓</span>
								) : (
									<ChevronDownIcon className={'h-5 w-5 text-gray-400 flex-shrink-0' + (open ? ' transform rotate-180' : '')} />
								)}
							</button>

							{open && (
								<div className="mt-1">
									<div className="flex gap-3">
										<div className="flex-1 min-w-0">
											<label className={labelClass}>{lang.step1.firstname}</label>
											<input
												type="text"
												className={this._inputClass('p' + i + '_firstname')}
												value={p.firstname}
												onChange={e => this.handleParticipantField(i, 'firstname', e.target.value)}
												onBlur={() => this.blurParticipantName(i, 'firstname')}
											/>
										</div>
										<div className="flex-1 min-w-0">
											<label className={labelClass}>{lang.step1.lastname}</label>
											<input
												type="text"
												className={this._inputClass('p' + i + '_lastname')}
												value={p.lastname}
												onChange={e => this.handleParticipantField(i, 'lastname', e.target.value)}
												onBlur={() => this.blurParticipantName(i, 'lastname')}
											/>
										</div>
									</div>
									{this._renderFieldError('p' + i + '_firstname')}
									{this._renderFieldError('p' + i + '_lastname')}

									<label className={labelClass}>{lang.step1.birthday}</label>
									<div className="flex gap-2">
										<div className="flex-1">
											<input
												ref={this._getParticipantRef(i, 'day')}
												type="text"
												inputMode="numeric"
												value={pDay}
												onChange={e => {
													const result = tools.parseDateDay(e.target.value)
													e.target.setCustomValidity(result.valid ? '' : 'Jour invalide')
													this._setParticipantBirthday(i, result.value, pMonth, pYear)
													if (result.advance)
														setTimeout(() => this._getParticipantRef(i, 'month').current.focus(), 0)
												}}
												onBlur={e => { if (e.target.value.length === 1) this._setParticipantBirthday(i, '0' + e.target.value, pMonth, pYear) }}
												placeholder="JJ"
												maxLength={2}
												className={this._inputClass('p' + i + '_birthday', 'text-center')}
											/>
										</div>
										<div className="flex-1">
											<input
												ref={this._getParticipantRef(i, 'month')}
												type="text"
												inputMode="numeric"
												value={pMonth}
												onChange={e => {
													const result = tools.parseDateMonth(e.target.value)
													e.target.setCustomValidity(result.valid ? '' : 'Mois invalide')
													this._setParticipantBirthday(i, pDay, result.value, pYear)
													if (result.advance)
														setTimeout(() => this._getParticipantRef(i, 'year').current.focus(), 0)
												}}
												onBlur={e => { if (e.target.value.length === 1) this._setParticipantBirthday(i, pDay, '0' + e.target.value, pYear) }}
												onKeyDown={e => {
													if (e.key === 'Backspace' && pMonth.length === 0) {
														e.preventDefault()
														this._getParticipantRef(i, 'day').current.focus()
													}
												}}
												placeholder="MM"
												maxLength={2}
												className={this._inputClass('p' + i + '_birthday', 'text-center')}
											/>
										</div>
										<div className="flex-1">
											<input
												ref={this._getParticipantRef(i, 'year')}
												type="text"
												inputMode="numeric"
												value={pYear}
												onChange={e => {
													const val = e.target.value.replace(/\D/g, '').slice(0, 4)
													this._setParticipantBirthday(i, pDay, pMonth, val)
												}}
												onKeyDown={e => {
													if (e.key === 'Backspace' && pYear.length === 0) {
														e.preventDefault()
														this._getParticipantRef(i, 'month').current.focus()
													}
												}}
												placeholder="AAAA"
												maxLength={4}
												className={this._inputClass('p' + i + '_birthday', 'text-center')}
											/>
										</div>
									</div>
									{this._renderFieldError('p' + i + '_birthday')}

									<label className={labelClass}>{lang.step1.email}{optionalSuffix}</label>
									<input
										type="email"
										className={this._inputClass('p' + i + '_email')}
										value={p.email}
										onChange={e => this.handleParticipantField(i, 'email', e.target.value)}
										placeholder="exemple@mail.com"
									/>

									{stays.length > 1 && (
										<>
											<label className={labelClass}>{lang.step2.select_stay}</label>
											<select
												className={this._inputClass('p' + i + '_stay_number')}
												value={p.stay_number || ''}
												onChange={e => this.handleParticipantField(i, 'stay_number', e.target.value ? parseInt(e.target.value, 10) : null)}
											>
												<option value="">{lang.step2.select_stay_placeholder}</option>
												{stays.map(s => (
													<option key={s.stay_number} value={s.stay_number}>
														{display_names[s.stay_number] || ('#' + s.stay_number)}{s.arrival ? ' — ' + s.arrival : ''}
													</option>
												))}
											</select>
											{this._renderFieldError('p' + i + '_stay_number')}
										</>
									)}
								</div>
							)}
						</div>
					)
				})}

				{this._renderError()}
			</div>
		)
	}

	// --- Étape 4 : Véhicules ---

	_renderStep3 = () => {
		const lang = this._getLangAssets().precheckin
		const display_names = this._buildStayDisplayNames()
		const shades = this._getThemeShades()
		const mandatory = (this.props.config_checkins && this.props.config_checkins.mandatory) || {}
		const labelClass = "block text-xs font-bold text-gray-500 mt-4 mb-1"
		const labelFirstClass = "block text-xs font-bold text-gray-500 mb-1"
		const optionalSuffix = <span className="font-medium text-gray-400 ml-1">({lang.optional})</span>
		return (
			<div className="px-4 pt-5">
				<h2 className="text-2xl font-extrabold text-gray-800 m-0">{lang.step3.subtitle}</h2>
				<p className="text-sm text-gray-500 mt-1 mb-0">{lang.step3.hint}</p>

				{this.state.vehicles.map((vehicle, i) => (
					<div key={i} className="bg-white border border-gray-200 rounded-2xl p-4 mt-4 shadow-sm">
						<div className="flex items-center justify-between mb-3">
							<p className="text-xs font-bold uppercase tracking-wider text-gray-400 m-0">🚗 {lang.step3.vehicle} {i + 1}</p>
							<button
								type="button"
								onClick={() => this.removeVehicle(i)}
								aria-label={lang.step3.vehicle + ' ' + (i + 1)}
								className="h-11 w-11 -my-2 -mr-2 rounded-xl flex items-center justify-center text-red-400 bg-transparent border-0"
							>
								<TrashIcon className="h-5 w-5" />
							</button>
						</div>

						<label className={labelFirstClass}>{lang.step3.plate_placeholder}</label>
						<input
							type="text"
							className={this._inputClass('v' + i + '_plate', 'uppercase')}
							value={vehicle.plate}
							onChange={e => this.handleVehicleField(i, 'plate', e.target.value.toUpperCase())}
							placeholder={lang.step3.plate_placeholder}
						/>
						{this._renderFieldError('v' + i + '_plate')}

						<label className={labelClass}>{lang.step3.vehicle_country_placeholder}</label>
						<select
							className={this._inputClass('v' + i + '_country')}
							value={vehicle.country}
							onChange={e => this.handleVehicleField(i, 'country', e.target.value)}
						>
							<option value="">{lang.step3.vehicle_country_placeholder}</option>
							{[...COUNTRIES].sort((a, b) => {
								const na = (lang.step3.countries[a.code] || a.code).toLowerCase()
								const nb = (lang.step3.countries[b.code] || b.code).toLowerCase()
								return na.localeCompare(nb)
							}).map(c => (
								<option key={c.code} value={c.code}>
									{c.flag} {lang.step3.countries[c.code]}
								</option>
							))}
						</select>
						{this._renderFieldError('v' + i + '_country')}

						<label className={labelClass}>{lang.step3.vehicle_type_placeholder}</label>
						<select
							className={this._inputClass('v' + i + '_vehicle_type')}
							value={vehicle.vehicle_type || ''}
							onChange={e => this.handleVehicleField(i, 'vehicle_type', e.target.value)}
						>
							<option value="">{lang.step3.vehicle_type_placeholder}</option>
							{lang.step3.vehicle_types.map(t => (
								<option key={t.value} value={t.value}>{t.label}</option>
							))}
						</select>
						{this._renderFieldError('v' + i + '_vehicle_type')}

						<label className={labelClass}>{lang.step3.vehicle_brand_placeholder}{!mandatory.vehicle_brand && optionalSuffix}</label>
						<select
							className={this._inputClass('v' + i + '_brand')}
							value={vehicle.brand || ''}
							onChange={e => this.handleVehicleField(i, 'brand', e.target.value)}
						>
							<option value="">{lang.step3.vehicle_brand_placeholder}</option>
							{VEHICLE_BRANDS.map(b => (
								<option key={b} value={b}>{b}</option>
							))}
							<option value="other">{lang.step3.vehicle_brand_other}</option>
						</select>
						{this._renderFieldError('v' + i + '_brand')}
						{vehicle.brand === 'other' && (
							<input
								type="text"
								className={this._inputClass('v' + i + '_brand', 'mt-2')}
								value={vehicle.brand_other || ''}
								onChange={e => this.handleVehicleField(i, 'brand_other', e.target.value)}
								placeholder={lang.step3.vehicle_brand_other_placeholder}
							/>
						)}

						<label className={labelClass}>{lang.step3.vehicle_color_placeholder}{!mandatory.vehicle_color && optionalSuffix}</label>
						<select
							className={this._inputClass('v' + i + '_color')}
							value={vehicle.color || ''}
							onChange={e => this.handleVehicleField(i, 'color', e.target.value)}
						>
							<option value="">{lang.step3.vehicle_color_placeholder}</option>
							{lang.step3.vehicle_colors.map(c => (
								<option key={c.value} value={c.value}>{c.label}</option>
							))}
						</select>
						{this._renderFieldError('v' + i + '_color')}

						{this.state.stays.length > 1 && (
							<>
								<label className={labelClass}>{lang.step3.select_stay}</label>
								<select
									className={this._inputClass('v' + i + '_stay_number')}
									value={vehicle.stay_number || ''}
									onChange={e => this.handleVehicleField(i, 'stay_number', e.target.value ? parseInt(e.target.value, 10) : null)}
								>
									<option value="">{lang.step3.select_stay_placeholder}</option>
									{this.state.stays.map(s => (
										<option key={s.stay_number} value={s.stay_number}>
											{display_names[s.stay_number] || ('#' + s.stay_number)}{s.arrival ? ' — ' + s.arrival : ''}
										</option>
									))}
								</select>
								{this._renderFieldError('v' + i + '_stay_number')}
							</>
						)}
					</div>
				))}

				<button
					type="button"
					onClick={this.addVehicle}
					className="w-full h-12 mt-4 rounded-2xl font-bold text-sm flex items-center justify-center gap-2 bg-transparent"
					style={{ border: '2px dashed ' + shades.color, color: shades.deep }}
				>
					<PlusIcon className="h-5 w-5" />
					{lang.step3.add_vehicle}
				</button>

				{this._renderError()}
			</div>
		)
	}

	// --- Étape 5 : Animaux ---

	_renderStepAnimals = () => {
		const lang = this._getLangAssets().precheckin
		const display_names = this._buildStayDisplayNames()
		const shades = this._getThemeShades()
		const mandatory = (this.props.config_checkins && this.props.config_checkins.mandatory) || {}
		const labelClass = "block text-xs font-bold text-gray-500 mt-4 mb-1"
		const labelFirstClass = "block text-xs font-bold text-gray-500 mb-1"
		const optionalSuffix = <span className="font-medium text-gray-400 ml-1">({lang.optional})</span>
		return (
			<div className="px-4 pt-5">
				<h2 className="text-2xl font-extrabold text-gray-800 m-0">{lang.step_animals.subtitle}</h2>
				<p className="text-sm text-gray-500 mt-1 mb-0">{lang.step_animals.hint}</p>

				{this.state.animals.map((animal, i) => (
					<div key={i} className="bg-white border border-gray-200 rounded-2xl p-4 mt-4 shadow-sm">
						<div className="flex items-center justify-between mb-3">
							<p className="text-xs font-bold uppercase tracking-wider text-gray-400 m-0">🐾 {lang.step_animals.animal} {i + 1}</p>
							<button
								type="button"
								onClick={() => this.removeAnimal(i)}
								aria-label={lang.step_animals.animal + ' ' + (i + 1)}
								className="h-11 w-11 -my-2 -mr-2 rounded-xl flex items-center justify-center text-red-400 bg-transparent border-0"
							>
								<TrashIcon className="h-5 w-5" />
							</button>
						</div>

						<label className={labelFirstClass}>{lang.step_animals.type}</label>
						<select
							className={this._inputClass('a' + i + '_type')}
							value={animal.type}
							onChange={e => this.handleAnimalField(i, 'type', e.target.value)}
						>
							<option value="">{lang.step_animals.type_placeholder}</option>
							<option value="dog">{lang.step_animals.type_dog}</option>
							<option value="cat">{lang.step_animals.type_cat}</option>
							<option value="other">{lang.step_animals.type_other}</option>
						</select>
						{this._renderFieldError('a' + i + '_type')}

						{animal.type === 'other' && (
							<input
								type="text"
								className={this._inputClass('a' + i + '_type', 'mt-2')}
								value={animal.type_other}
								onChange={e => this.handleAnimalField(i, 'type_other', e.target.value)}
								placeholder={lang.step_animals.type_other_placeholder}
							/>
						)}

						<label className={labelClass}>{lang.step_animals.name}{!mandatory.animal_name && optionalSuffix}</label>
						<input
							type="text"
							className={this._inputClass('a' + i + '_name')}
							value={animal.name}
							onChange={e => this.handleAnimalField(i, 'name', e.target.value)}
							onBlur={() => this.blurAnimalName(i)}
						/>
						{this._renderFieldError('a' + i + '_name')}

						<label className={labelClass}>{lang.step_animals.weight}{!mandatory.animal_weight && optionalSuffix}</label>
						<select
							className={this._inputClass('a' + i + '_weight')}
							value={animal.weight}
							onChange={e => this.handleAnimalField(i, 'weight', e.target.value)}
						>
							<option value="">{lang.step_animals.weight_placeholder}</option>
							{(() => {
								const opts = []
								for (let w = 1.0; w <= 30.0; w = Math.round((w + 0.5) * 10) / 10)
									opts.push(<option key={w} value={w}>{w.toFixed(1)} kg</option>)
								return opts
							})()}
						</select>
						{this._renderFieldError('a' + i + '_weight')}

						<label className={labelClass}>{lang.step_animals.chip}{!mandatory.animal_chip && optionalSuffix}</label>
						<input
							type="text"
							className={this._inputClass('a' + i + '_chip', 'uppercase')}
							value={animal.chip}
							onChange={e => this.handleAnimalField(i, 'chip', e.target.value.toUpperCase())}
						/>
						{this._renderFieldError('a' + i + '_chip')}

						<label className={labelClass}>{lang.step_animals.last_vaccine}{!mandatory.animal_last_vaccine && optionalSuffix}</label>
						{(() => {
							const vaxParts = (animal.last_vaccine || '').split('/')
							const vaxDay = vaxParts[0] || ''
							const vaxMonth = vaxParts[1] || ''
							const vaxYear = vaxParts[2] || ''
							return (
								<div className="flex gap-2">
									<div className="flex-1">
										<input
											ref={this._getAnimalRef(i, 'vax_day')}
											type="text"
											inputMode="numeric"
											value={vaxDay}
											onChange={e => {
												const result = tools.parseDateDay(e.target.value)
												e.target.setCustomValidity(result.valid ? '' : 'Jour invalide')
												this._setAnimalVaccineDate(i, result.value, vaxMonth, vaxYear)
												if (result.advance)
													setTimeout(() => this._getAnimalRef(i, 'vax_month').current.focus(), 0)
											}}
											onBlur={e => { if (e.target.value.length === 1) this._setAnimalVaccineDate(i, '0' + e.target.value, vaxMonth, vaxYear) }}
											placeholder="JJ"
											maxLength={2}
											className={this._inputClass('a' + i + '_last_vaccine', 'text-center')}
										/>
									</div>
									<div className="flex-1">
										<input
											ref={this._getAnimalRef(i, 'vax_month')}
											type="text"
											inputMode="numeric"
											value={vaxMonth}
											onChange={e => {
												const result = tools.parseDateMonth(e.target.value)
												e.target.setCustomValidity(result.valid ? '' : 'Mois invalide')
												this._setAnimalVaccineDate(i, vaxDay, result.value, vaxYear)
												if (result.advance)
													setTimeout(() => this._getAnimalRef(i, 'vax_year').current.focus(), 0)
											}}
											onBlur={e => { if (e.target.value.length === 1) this._setAnimalVaccineDate(i, vaxDay, '0' + e.target.value, vaxYear) }}
											onKeyDown={e => {
												if (e.key === 'Backspace' && vaxMonth.length === 0) {
													e.preventDefault()
													this._getAnimalRef(i, 'vax_day').current.focus()
												}
											}}
											placeholder="MM"
											maxLength={2}
											className={this._inputClass('a' + i + '_last_vaccine', 'text-center')}
										/>
									</div>
									<div className="flex-1">
										<input
											ref={this._getAnimalRef(i, 'vax_year')}
											type="text"
											inputMode="numeric"
											value={vaxYear}
											onChange={e => {
												const val = e.target.value.replace(/\D/g, '').slice(0, 4)
												this._setAnimalVaccineDate(i, vaxDay, vaxMonth, val)
											}}
											onKeyDown={e => {
												if (e.key === 'Backspace' && vaxYear.length === 0) {
													e.preventDefault()
													this._getAnimalRef(i, 'vax_month').current.focus()
												}
											}}
											placeholder="AAAA"
											maxLength={4}
											className={this._inputClass('a' + i + '_last_vaccine', 'text-center')}
										/>
									</div>
								</div>
							)
						})()}
						{this._renderFieldError('a' + i + '_last_vaccine')}

						{this.state.stays.length > 1 && (
							<>
								<label className={labelClass}>{lang.step_animals.select_stay}</label>
								<select
									className={this._inputClass('a' + i + '_stay_number')}
									value={animal.stay_number || ''}
									onChange={e => this.handleAnimalField(i, 'stay_number', e.target.value ? parseInt(e.target.value, 10) : null)}
								>
									<option value="">{lang.step_animals.select_stay_placeholder}</option>
									{this.state.stays.map(s => (
										<option key={s.stay_number} value={s.stay_number}>
											{display_names[s.stay_number] || ('#' + s.stay_number)}{s.arrival ? ' — ' + s.arrival : ''}
										</option>
									))}
								</select>
							</>
						)}
					</div>
				))}

				<button
					type="button"
					onClick={this.addAnimal}
					className="w-full h-12 mt-4 rounded-2xl font-bold text-sm flex items-center justify-center gap-2 bg-transparent"
					style={{ border: '2px dashed ' + shades.color, color: shades.deep }}
				>
					<PlusIcon className="h-5 w-5" />
					{lang.step_animals.add_animal}
				</button>

				{this._renderError()}
			</div>
		)
	}

	// --- Étape 6 : Heure d'arrivée ---

	// Horaires applicables à un séjour : ceux de son type d'hébergement
	// (paramètres généraux, clé stay-hours), repli locatif quand l'horaire
	// emplacement n'est pas défini, repli config pré-checkin historique
	// si stay-hours absent.
	_getStayHours = (stay) => {
		const cc = this.props.config_checkins || {}
		const sh = cc.stay_hours
		if (!sh || !sh.locatif)
			return { arrival: cc.arrival_time_hour != null ? cc.arrival_time_hour : null, departure: cc.departure_time_hour != null ? cc.departure_time_hour : null }
		const loc = sh.locatif || {}
		const emp = sh.emplacement || {}
		const is_emplacement = !!(stay && stay.stay_type === 'camping')
		return {
			arrival: is_emplacement && emp.arrival != null ? emp.arrival : (loc.arrival != null ? loc.arrival : null),
			departure: is_emplacement && emp.departure != null ? emp.departure : (loc.departure != null ? loc.departure : null)
		}
	}

	// Heure d'arrivée tardive : paramètres généraux (stay_hours), repli sur
	// l'ancien champ pré-checkin. Null si non paramétrée.
	_getLateHour = () => {
		const cc = this.props.config_checkins || {}
		if (cc.stay_hours && cc.stay_hours.late_arrival != null)
			return cc.stay_hours.late_arrival
		return cc.late_arrival_hour != null ? cc.late_arrival_hour : null
	}

	// Fenêtre d'arrivée conseillée : de l'heure d'arrivée du type d'hébergement
	// (la plus exigeante en cas de types mixtes sur la même date) jusqu'à
	// l'heure d'arrivée tardive. Null si rien n'est paramétré.
	_getIdealWindow = (context_stays) => {
		const list = (context_stays && context_stays.length > 0) ? context_stays : [null]
		const starts = list.map(s => this._getStayHours(s).arrival).filter(h => h != null)
		const late_hour = this._getLateHour()
		if (starts.length === 0 && late_hour === null)
			return null
		const from = starts.length > 0 ? Math.max(...starts) : 0
		const to = late_hour !== null ? late_hour : 24
		if (from >= to)
			return null
		return { from: from, to: to }
	}

	// Avertissement pour UN séjour : trois fenêtres, chacune avec le message
	// du type d'hébergement (repli locatif) et son seuil pour {heure}.
	// priority : 3 = tardive, 2 = avant les départs, 1 = pendant la préparation
	_getWarningForStay = (hour, stay, pickStr) => {
		const cc = this.props.config_checkins || {}
		const hours = this._getStayHours(stay)
		const is_emplacement = !!(stay && stay.stay_type === 'camping')
		const typedStr = (locatif_key, emplacement_key) => {
			const specific = is_emplacement ? pickStr(cc[emplacement_key]) : null
			return specific || pickStr(cc[locatif_key])
		}
		const late_hour = this._getLateHour()
		if (cc.late_arrival_check && late_hour != null && hour >= late_hour)
		{
			const text = pickStr(cc.late_arrival_str)
			if (text)
				return { text: text, threshold: late_hour, priority: 3 }
		}
		if (cc.departure_hour_check && hours.departure != null && hour < hours.departure)
		{
			const text = typedStr('departure_time_str', 'emplacement_departure_time_str')
			if (text)
				return { text: text, threshold: hours.departure, priority: 2 }
		}
		if (cc.arrival_time_check && hours.arrival != null && hour < hours.arrival)
		{
			const text = typedStr('arrival_time_str', 'emplacement_arrival_time_str')
			if (text)
				return { text: text, threshold: hours.arrival, priority: 1 }
		}
		return null
	}

	_getArrivalWarning = (time_str, context_stays) => {
		if (!time_str)
			return null
		const hour = parseInt(time_str.split(':')[0], 10)
		const lang = this.state.selected_lang || 'fr'
		const pickStr = (translations) => {
			if (!Array.isArray(translations))
				return null
			const entry = translations.find(t => t.lang === lang) || translations.find(t => t.lang === 'fr')
			return (entry && entry.text) ? entry.text : null
		}
		// Chaque séjour est évalué avec SES horaires et SES messages ; en cas de
		// types mixtes sur la même date, on affiche le plus important (tardive
		// d'abord, puis le seuil le plus exigeant)
		const list = (context_stays && context_stays.length > 0) ? context_stays : [null]
		const candidates = list
			.map(s => this._getWarningForStay(hour, s, pickStr))
			.filter(w => w !== null)
		if (candidates.length === 0)
			return null
		candidates.sort((a, b) => (b.priority - a.priority) || (b.threshold - a.threshold))
		const warning = candidates[0]
		return warning.text.replace(/\{heure\}/g, warning.threshold + 'h')
	}

	_renderArrivalWarning = (time_str, context_stays) => {
		const warning = this._getArrivalWarning(time_str, context_stays)
		if (!warning)
			return null
		return (
			<div key={warning} className="pc-pop rounded-xl bg-amber-50 border border-amber-200 p-4 mt-4">
				<div className="flex">
					<div className="flex-shrink-0">
						<ExclamationIcon className="h-5 w-5 text-amber-400" aria-hidden="true" />
					</div>
					<div className="ml-3">
						<p className="text-sm font-medium text-amber-800 m-0">{warning}</p>
					</div>
				</div>
			</div>
		)
	}

	_renderStep4 = () => {
		const lang = this._getLangAssets().precheckin
		const { stays, estimate_arrival, estimate_arrivals, field_errors } = this.state
		const shades = this._getThemeShades()
		const cc = this.props.config_checkins || {}
		const start_hour = (cc.block_arrival_time_check && cc.block_arrival_time_hour != null && cc.block_arrival_time_hour > 8)
			? cc.block_arrival_time_hour
			: 8
		const hours = []
		for (let h = start_hour; h < 24; h++) {
			for (let m = 0; m < 60; m += 30) {
				hours.push(String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0'))
			}
		}
		const unique_dates = [...new Set(stays.map(s => s.arrival).filter(Boolean))]
		const is_multi_day = unique_dates.length > 1
		const selectedStay = stays.find(s => s.stay_number === this.state.selected_stay)

		const renderTimeGrid = (selected, onSelect, err_key, context_stays) => {
			const ideal = this._getIdealWindow(context_stays)
			const late_hour = this._getLateHour()
			return (
				<>
					<div className="grid grid-cols-4 gap-2">
						{hours.map(h => {
							const on = selected === h
							const slot = parseInt(h.split(':')[0], 10) + (parseInt(h.split(':')[1], 10) >= 30 ? 0.5 : 0)
							const is_ideal = !!(ideal && slot >= ideal.from && slot < ideal.to)
							const is_late = late_hour !== null && slot >= late_hour
							// Tous les créneaux gardent un fond blanc (grisé = se lirait
							// « indisponible ») ; les conseillés se distinguent par un
							// contour à la couleur du thème
							let style = { border: '1.5px solid ' + (field_errors[err_key] ? '#dc2626' : '#e5e7eb'), backgroundColor: '#ffffff', color: '#6b7280' }
							if (is_ideal)
								style = { border: '1.5px solid ' + (field_errors[err_key] ? '#dc2626' : shades.color), backgroundColor: '#ffffff', color: shades.deep }
							if (on)
								style = { border: '1.5px solid ' + shades.color, backgroundColor: shades.color, color: '#ffffff', boxShadow: '0 4px 12px ' + shades.glow }
							return (
								<button
									key={h}
									type="button"
									onClick={() => onSelect(h)}
									className="h-11 rounded-xl text-sm font-bold"
									style={style}
								>
									{h}
									{is_late && (
										<span className="ml-1" style={{ fontSize: '10px', lineHeight: 1 }} aria-hidden="true">🌙</span>
									)}
								</button>
							)
						})}
					</div>
					{(ideal || late_hour !== null) && (
						<div className="mt-3">
							{ideal && (
								<p className="text-xs font-semibold text-gray-400 m-0 flex items-center gap-2">
									<span className="inline-block h-3 w-3 rounded bg-white flex-shrink-0" style={{ border: '1.5px solid ' + shades.color }} />
									{lang.step4.ideal_hint}
								</p>
							)}
							{late_hour !== null && (
								<p className="text-xs font-semibold text-gray-400 m-0 mt-1 flex items-center gap-2">
									<span className="inline-block w-3 text-center flex-shrink-0" style={{ fontSize: '11px', lineHeight: 1 }}>🌙</span>
									{lang.step4.late_hint}
								</p>
							)}
						</div>
					)}
					{this._renderFieldError(err_key)}
				</>
			)
		}

		return (
			<div className="px-4 pt-5">
				<h2 className="text-2xl font-extrabold text-gray-800 m-0">{lang.step4.subtitle}</h2>
				<p className="text-sm text-gray-500 mt-1 mb-0">{lang.step4.hint}</p>

				{is_multi_day ? (
					unique_dates.map(date => (
						<div key={date}>
							{this._renderCard('🕐 ' + lang.step4.arrival_date_label + ' ' + date, (
								<>
									{renderTimeGrid(estimate_arrivals[date] || '', (h) => this.handleArrivalTimeForDate(date, h), 'arrival_' + date, stays.filter(s => s.arrival === date))}
									{this._renderArrivalWarning(estimate_arrivals[date] || '', stays.filter(s => s.arrival === date))}
								</>
							))}
						</div>
					))
				) : (
					this._renderCard('🕐 ' + lang.step4.card_hour + (selectedStay && selectedStay.arrival ? ' — ' + selectedStay.arrival : ''), (
						<>
							{renderTimeGrid(estimate_arrival, this.handleArrivalTime, 'arrival', selectedStay ? [selectedStay] : stays)}
							{this._renderArrivalWarning(estimate_arrival, selectedStay ? [selectedStay] : stays)}
						</>
					))
				)}

				{this._renderError()}
			</div>
		)
	}

	// --- Récapitulatif ---

	_renderSummary = () => {
		const lang = this._getLangAssets().precheckin
		const shades = this._getThemeShades()
		const cc = this.props.config_checkins || {}
		const display_names = this._buildStayDisplayNames()
		const { client, participants, vehicles, animals, stays, selected_stay } = this.state
		const vehicles_filtered = vehicles.filter(v => v.plate && v.plate.trim())

		const editBtn = (target) => (
			<button
				type="button"
				onClick={() => this.goToStep(target)}
				className="text-xs font-extrabold rounded-lg px-3 py-2 -my-2 border-0"
				style={{ backgroundColor: shades.soft, color: shades.deep }}
			>
				{lang.summary.edit}
			</button>
		)

		const renderLines = (rows) => rows.map((r, idx) => (
			<div
				key={idx}
				className="flex items-start justify-between gap-3 py-2"
				style={idx < rows.length - 1 ? { borderBottom: '1px dashed #e5e7eb' } : {}}
			>
				<span className="text-xs font-semibold text-gray-400 flex-shrink-0 mt-0.5">{r.k}</span>
				<span className="text-sm font-bold text-gray-700 text-right min-w-0">{r.v}</span>
			</div>
		))

		// Responsable
		const responsible_rows = []
		if (client.civility)
		{
			let civ = ''
			if (client.civility === 'woman')
				civ = lang.step1.civil_madame
			else if (client.civility === 'man')
				civ = lang.step1.civil_monsieur
			else
				civ = lang.step1.civil_autre
			responsible_rows.push({ k: lang.step1.civil, v: civ })
		}
		responsible_rows.push({ k: lang.step1.lastname, v: parseName(client.firstname) + ' ' + parseName(client.lastname) })
		if (client.birthday)
			responsible_rows.push({ k: lang.step1.birthday, v: client.birthday })
		if (client.place_of_birth)
			responsible_rows.push({ k: lang.step1.place_of_birth, v: parseName(client.place_of_birth) })
		if (client.email)
			responsible_rows.push({ k: lang.step1.email, v: client.email })
		if (client.phone)
			responsible_rows.push({ k: lang.step1.phone, v: client.phone })
		if (client.street || client.city)
			responsible_rows.push({
				k: lang.summary.address,
				v: (
					<>
						{client.street && <span>{client.street}<br /></span>}
						{client.zipcode && <span>{client.zipcode} </span>}
						{client.city && <span>{parseName(client.city)}</span>}
						{client.country && <span><br />{parseName(client.country)}</span>}
					</>
				)
			})
		if (client.id_type || client.id_number)
		{
			let id_label = ''
			if (client.id_type === 'passport')
				id_label = lang.step1.id_type_passport
			else if (client.id_type === 'id_card')
				id_label = lang.step1.id_type_id_card
			else if (client.id_type === 'driving_license')
				id_label = lang.step1.id_type_driving_license
			responsible_rows.push({ k: lang.step1.id_type, v: id_label + (client.id_number ? ' · ' + client.id_number : '') })
		}

		// Participants (responsable inclus)
		const allParticipants = [
			{ lastname: client.lastname, firstname: client.firstname, birthday: client.birthday, email: client.email, stay_number: selected_stay },
			...participants
		]
		const participant_rows = allParticipants.map((p, i) => {
			const stay = stays.length > 1 ? stays.find(s => s.stay_number === p.stay_number) : null
			return {
				k: String(i + 1),
				v: (
					<>
						{parseName(p.lastname)} {parseName(p.firstname)}{p.birthday ? ' · ' + p.birthday : ''}
						{stay && <span className="text-gray-400 font-semibold"> ({display_names[stay.stay_number] || ('#' + stay.stay_number)})</span>}
					</>
				)
			}
		})

		// Véhicules
		const vehicle_rows = vehicles_filtered.map((v, i) => {
			const vstay = stays.length > 1 && v.stay_number ? stays.find(s => s.stay_number === v.stay_number) : null
			const type_entry = lang.step3.vehicle_types.find(t => t.value === v.vehicle_type)
			const brand_label = v.brand === 'other' ? (parseName(v.brand_other) || lang.step3.vehicle_brand_other) : parseName(v.brand)
			const color_entry = lang.step3.vehicle_colors.find(c => c.value === v.color)
			const parts = [type_entry ? type_entry.label : null, brand_label, color_entry ? color_entry.label : null].filter(Boolean)
			return {
				k: v.plate,
				v: (
					<>
						{parts.join(' · ')}
						{vstay && <span className="text-gray-400 font-semibold"> ({display_names[vstay.stay_number] || ('#' + vstay.stay_number)})</span>}
					</>
				)
			}
		})

		// Animaux
		const animal_rows = animals.map((a, i) => {
			const astay = stays.length > 1 && a.stay_number ? stays.find(s => s.stay_number === a.stay_number) : null
			let typeLabel = ''
			if (a.type === 'dog')
				typeLabel = lang.step_animals.type_dog
			else if (a.type === 'cat')
				typeLabel = lang.step_animals.type_cat
			else if (a.type === 'other')
				typeLabel = parseName(a.type_other) || lang.step_animals.type_other
			const details = [
				a.weight ? parseFloat(a.weight).toFixed(1) + ' kg' : null,
				a.chip || null
			].filter(Boolean)
			return {
				k: parseName(a.name || '') || typeLabel || String(i + 1),
				v: (
					<>
						{[typeLabel, ...details].filter(Boolean).join(' · ')}
						{astay && <span className="text-gray-400 font-semibold"> ({display_names[astay.stay_number] || ('#' + astay.stay_number)})</span>}
					</>
				)
			}
		})

		// Heure d'arrivée
		const unique_dates = [...new Set(stays.map(s => s.arrival).filter(Boolean))]
		const is_multi_day = unique_dates.length > 1
		let arrival_rows = []
		if (is_multi_day)
			arrival_rows = unique_dates.filter(d => this.state.estimate_arrivals[d]).map(d => ({ k: d, v: this.state.estimate_arrivals[d] }))
		else if (this.state.estimate_arrival)
			arrival_rows = [{ k: unique_dates[0] || '', v: this.state.estimate_arrival }]

		const participants_target = cc.participants !== false ? 3 : 2

		return (
			<div className="px-4 pt-5">
				<h2 className="text-2xl font-extrabold text-gray-800 m-0">{lang.summary.subtitle}</h2>

				{this._renderCard('👤 ' + lang.summary.card_responsible, renderLines(responsible_rows), editBtn(1))}
				{this._renderCard('👨‍👩‍👧 ' + lang.step2.title + ' · ' + allParticipants.length, renderLines(participant_rows), editBtn(participants_target))}
				{vehicle_rows.length > 0 && this._renderCard('🚗 ' + lang.step3.title, renderLines(vehicle_rows), editBtn(4))}
				{animal_rows.length > 0 && this._renderCard('🐾 ' + lang.step_animals.title, renderLines(animal_rows), editBtn(5))}
				{arrival_rows.length > 0 && this._renderCard('🕐 ' + lang.step4.title, renderLines(arrival_rows), editBtn(6))}

				{this._renderError()}
			</div>
		)
	}

	// --- Confirmation ---

	_renderConfirmation = () => {
		const lang = this._getLangAssets().precheckin
		const shades = this._getThemeShades()
		const { user_exists, show_password_form, new_password, creating_account, account_error, show_notification_prompt, client, stays, selected_stay } = this.state
		const stay = stays.find(s => s.stay_number === selected_stay) || stays[0] || null
		const message = (stay && stay.arrival)
			? lang.confirmation.saved_message.replace('{date}', stay.arrival)
			: lang.confirmation.message
		const thanks = (client.firstname && client.firstname.trim())
			? lang.confirmation.thanks.replace('{prenom}', parseName(client.firstname))
			: lang.confirmation.subtitle
		const confetti_colors = [shades.color, '#f2b134', '#e2694f', shades.color, '#f2b134', '#7aa8e0', '#e2694f', shades.color]
		const confetti_lefts = [8, 18, 30, 44, 57, 68, 80, 91]
		const confetti_delays = [0, 0.6, 1.4, 0.2, 1.9, 0.9, 1.1, 0.4]
		const show_next_card = show_notification_prompt || user_exists === false
		const nextRow = (emoji, title, text, onClick) => (
			<button type="button" onClick={onClick} className="w-full flex items-start gap-3 py-2 bg-transparent border-0 p-0 text-left">
				<span className="h-10 w-10 rounded-xl flex items-center justify-center text-lg flex-shrink-0" style={{ backgroundColor: shades.soft }} aria-hidden="true">{emoji}</span>
				<span className="min-w-0 flex-1">
					<span className="block text-sm font-bold text-gray-800">{title}</span>
					<span className="block text-xs text-gray-500 leading-relaxed mt-0.5">{text}</span>
				</span>
				<ChevronDownIcon className="h-5 w-5 text-gray-400 flex-shrink-0 transform -rotate-90 mt-2" />
			</button>
		)
		return (
			<div
				className="pc-form min-h-screen relative overflow-hidden px-4 pb-10"
				style={{ backgroundColor: shades.page, '--pc-theme': shades.color, '--pc-glow': shades.glow }}
			>
				<div className="pc-confetti" aria-hidden="true">
					{confetti_lefts.map((left, i) => (
						<i key={i} style={{ left: left + '%', backgroundColor: confetti_colors[i], animationDelay: confetti_delays[i] + 's' }} />
					))}
				</div>

				<div className="pc-burst mx-auto mt-12 h-24 w-24 rounded-full flex items-center justify-center" style={{ backgroundColor: shades.soft }}>
					<div className="h-16 w-16 rounded-full flex items-center justify-center text-white text-3xl font-extrabold" style={{ backgroundColor: shades.color, boxShadow: '0 10px 26px ' + shades.glow }}>
						✓
					</div>
				</div>
				<h2 className="text-2xl font-extrabold text-gray-800 text-center mt-6 mb-0">{thanks}</h2>
				<p className="text-sm text-gray-500 text-center leading-relaxed mt-2 mb-0 px-4">{message}</p>

				{show_next_card && this._renderCard('📋 ' + lang.confirmation.next_title, (
					<>
						{show_notification_prompt && nextRow('🔔', lang.confirmation.notif_title, lang.confirmation.notif_text, () => {
							if (this.props.handleAcceptNotifications)
								this.props.handleAcceptNotifications(true)
							this.setState({ show_notification_prompt: false })
						})}
						{user_exists === false && !show_password_form && nextRow('🔑', lang.confirmation.create_account_btn, lang.confirmation.account_text, () => this.setState({ show_password_form: true }))}
						{show_password_form && (
							<div className="pt-1">
								<label className="block text-xs font-bold text-gray-500 mb-1">{lang.confirmation.password_label}</label>
								<input
									type="password"
									className="pc-input"
									value={new_password}
									onChange={e => this.setState({ new_password: e.target.value, account_error: null })}
									placeholder={lang.confirmation.password_hint}
								/>
								{account_error && (
									<p role="alert" className="text-sm font-medium text-red-600 mt-1 mb-0">{account_error}</p>
								)}
								<button
									type="button"
									onClick={this.createAccount}
									disabled={creating_account}
									className="mt-3 w-full py-3 rounded-2xl text-white font-bold disabled:opacity-50 border-0"
									style={{ backgroundColor: shades.color }}
								>
									{creating_account ? lang.confirmation.creating_account : lang.confirmation.create_account_submit}
								</button>
							</div>
						)}
					</>
				))}

				<button
					type="button"
					onClick={() => this.setState({ redirect: true })}
					className={show_password_form
						? 'mt-4 w-full h-11 bg-transparent border-0 text-sm font-bold text-gray-400'
						: 'mt-8 w-full py-4 rounded-2xl text-white font-bold text-lg border-0'
					}
					style={show_password_form ? {} : { backgroundColor: shades.color, boxShadow: '0 8px 22px ' + shades.glow }}
				>
					{user_exists === false ? lang.confirmation.discover : lang.confirmation.back_to_account}
				</button>
			</div>
		)
	}

	// --- Écran sans séjour ---

	_renderNoStay = () => {
		const lang = this._getLangAssets().precheckin
		const shades = this._getThemeShades()
		return (
			<div className="pc-form min-h-screen px-4 flex flex-col justify-center" style={{ backgroundColor: shades.page }}>
				<div className="bg-white border border-gray-200 rounded-3xl shadow-sm p-8 text-center">
					<p className="m-0" style={{ fontSize: '52px' }} aria-hidden="true">🏕️</p>
					<p className="text-gray-600 leading-relaxed mt-4 mb-8">{lang.errors.no_stay}</p>
					<button
						type="button"
						onClick={() => this.setState({ redirect: true })}
						className="w-full py-4 rounded-2xl text-white font-bold text-lg border-0"
						style={{ backgroundColor: shades.color, boxShadow: '0 8px 22px ' + shades.glow }}
					>
						{lang.no_stay_back}
					</button>
				</div>
			</div>
		)
	}

	render() {
		if (this.state.redirect)
			return <Redirect to="/" />
		if (this.props.config_checkins && this.props.config_checkins.activate === false)
			return <Redirect to="/" />

		if (this.state.loading_client || this.state.loading_stays || this.state.loading_precheckins)
		{
			return (
				<div>
					{this._renderHeader(this._getLangAssets().precheckin.title)}
					<div className="rounded-t-3xl z-10 bg-white" style={{ marginTop: '-2rem' }}>
						<div className="loading">
							<Loader />
						</div>
					</div>
				</div>
			)
		}

		if (this.state.stays.length === 0)
			return this._renderNoStay()

		if (this.state.submitted)
			return this._renderConfirmation()

		const { step, nav_direction } = this.state
		const shades = this._getThemeShades()
		let content = this._renderSummary()
		if (step === 0)
			content = this._renderStep0()
		else if (step === 1)
			content = this._renderStep1()
		else if (step === 2)
			content = this._renderStepMyParticipation()
		else if (step === 3)
			content = this._renderStep2()
		else if (step === 4)
			content = this._renderStep3()
		else if (step === 5)
			content = this._renderStepAnimals()
		else if (step === 6)
			content = this._renderStep4()

		const step_variants = {
			enter: (direction) => ({ opacity: 0, x: direction >= 0 ? 48 : -48 }),
			center: { opacity: 1, x: 0 },
			exit: (direction) => ({ opacity: 0, x: direction >= 0 ? -48 : 48 })
		}

		return (
			<div
				className="min-h-screen pc-form"
				style={{ backgroundColor: shades.page, '--pc-theme': shades.color, '--pc-glow': shades.glow }}
			>
				{step > 0 && this._renderShellHeader()}
				<AnimatePresence exitBeforeEnter initial={false} custom={nav_direction}>
					<motion.div
						key={step}
						custom={nav_direction}
						variants={step_variants}
						initial="enter"
						animate="center"
						exit="exit"
						transition={{ duration: 0.25, ease: 'easeOut' }}
						className="pb-36"
					>
						{content}
					</motion.div>
				</AnimatePresence>
				{this._renderStickyCta()}
			</div>
		)
	}
}

export default Precheckin
